import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../../layouts';
import axios from 'axios';
import configBase from '../../../../../configBase';
import {verificaCache} from '../../../../../verificaCache';
import InputMask from 'react-input-mask';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from "date-fns/locale/pt-BR";
import 'datatables.net';
import 'datatables.net-dt';
import {DropzoneDialog} from 'material-ui-dropzone';
import ReactToPrint from 'react-to-print';
import readXlsxFile from 'read-excel-file';
//import TransferenciaLista from './components/TransferenciaLista';

import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';



class Formulario extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      stepper: 0,// Posição inicial (0) do formulário
      showButtonBack: false,// Botão voltar
      showButtonFinished: false,// Botão concluir
      showButtonNext: true,// Botão avançar
      showButtonPrint: false,// Botão imprimir
      imprimir: true,
      errorRequest: false,
      msgErrorRequest: "",

      fieldStep1: {
        reteveAdesao: {value: false, required: true, error: '', model: 'company', type: ''},
        cnpj: {value: '', required: true, error: '', loading: false, model: 'company', type: ''},
        homePhone: {value: '', required: false, error: '', model: 'company', type: 'fone'},
        cellPhone: {value: '', required: true, error: '', model: 'company', type: 'cel'},
        cellPhone2: {value: '', required: false, error: '', model: 'company', type: 'cel'},
        fantasyName: {value: '', required: true, error: '', model: 'company', type: ''},
        businessName: {value: '', required: true, error: '', model: 'company', type: ''},
        cep: {value: '', required: true, error: '', model: 'company', type: ''},
        addressType: {value: 'null', required: true, error: '', loading: false, model: 'company', type: 'number'},
        address: {value: '', required: true, error: '', loading: false, model: 'company', type: ''},
        addressNumber: {value: 1, required: true, error: '', model: 'company', type: 'number'},
        state: {value: 'null', required: true, error: '', loading: false, model: 'company', type: 'number'},
        addressComplement: {value: '', required: false, error: '', model: 'company', type: ''},
        city: {value: 'null', required: true, error: '', loading: false, model: 'company', type: 'number'},
        district: {value: 'null', required: true, error: '', loading: false, model: 'company', type: 'number'},
        legalResponsible: {value: '', required: true, error: '', model: 'company', type: 'text'},
        legalResponsibleCpf: {value: '', required: true, error: '', model: 'company', type: ''},
        infoEmailInvoice: {value: '', required: true, error: '', loading: false, model: 'company', type: 'email'},
        plansListChosen: {value: [], required: true, error: '', loading: false, model: 'company', type: ''},
      },

      plansList: [],
      plansFullList: [],
      plansSelectedId: {value: 'null', required: true, error: '', type: ''},

      stateList: [],
      addressTypeList: [],
      cityList: [],
      districtList: [],

      fullScreenModal: false,

      imagesDocsUrl: {
        cpf: {url: '', required: false, error: ''},
        rg: {url: '', required: false, error: ''},
        rg2: {url: '', required: false, error: ''},
        address: {url: '', required: false, error: ''},
        cnpj: {url: '', required: false, error: ''},
        physicalContract1: {url: '', required: false, error: ''},
        others: {url: '', required: false, error: ''},
        usersTable: {url: '', required: false, error: ''},
      },
      dropzoneDialog: false,
      typeFile: '',

      checkFile: false,
      checkForm: false,

      typeMsgUsersTable: 'info',
      msgUsersTable: 'Nenhum arquivo anexado para validar',
      orientationStepper: 'horizontal',
      holderList: [
        {
          firstName: {value: '', required: true, error: '', model: 'holder', type: 'text'},
          cpf: {value: '', required: true, error: '', model: 'holder', type: ''},
          email: {value: '', required: false, error: '', model: 'holder', type: 'email'},
          cellPhone: {value: '', required: true, error: '', model: 'holder', type: ''},
          rg: {value: '', required: true, error: '', model: 'holder', type: 'number'},
          rgEmitter: {value: '', required: true, error: '', model: 'holder', type: 'text'},
          dateOfBirth: {value: null, required: true, error: '', model: 'holder', type: 'date'},
          motherName: {value: '', required: true, error: '', model: 'holder', type: 'text'},
          gender: {value: 'null', required: true, error: '', model: 'holder', type: ''},
          plansId: {value: 'null', required: true, error: '', model: 'holder', type: ''},
          susNumber: {value: '', required: false, error: '', model: 'holder', type: 'number'},
          dependents: [
            {
              firstName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
              cpf: {value: '', required: true, error: '', model: 'dependent', type: ''},
              email: {value: '', required: false, error: '', model: 'dependent', type: 'email'},
              cellPhone: {value: '', required: true, error: '', model: 'dependent', type: ''},
              rg: {value: '', required: true, error: '', model: 'dependent', type: 'number'},
              rgEmitter: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
              dateOfBirth: {value: null, required: true, error: '', model: 'dependent', type: 'date'},
              motherName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
              gender: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
              parentage: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
              plansId: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
              susNumber: {value: '', required: false, error: '', model: 'dependent', type: 'number'},
            },
          ],
        },
      ],
      holderIndex: 0,
      holderDeleteIndex: 0,
      modalConfirmRemoveHolder: false,
      dependentIndex: 0,
      isDependentEdit: false,
      modalAddDependent: false,
      modalConfirmRemoveDependent: false,
      dependentDeleteIndex: 0,
      modalAddHolder: false,
      isHolderEdit: false,
      planRemoveIndex: 0,
      modalConfirmRemovePlan: false,
      planoTipoFaixa: true,

      salesmanId: '',
      brokerId: '',
      companyId: null,

      value_total: "0,00",
      totalBeneficiaries: 0,
      totalDependents: 0,
      totalHolder: 0,
      nameHead: '',
      loadingButtonNext: false,

      finishedModal: false,
      finishedLoading: false,
      finishedLoadingMsg: 'BUSCANDO DADOS DO VENDEDOR...',
      finishedModalMinWidth: 300,
      finishedLoadingCompleted: 10,
      proposalSuccess: false,

      localList: [],
      localSelect: 'null',
      disabledLocalSelect: false,
      disabledPlansList: true,
      proposalNumber: '',

      listSalesman: [],
      chooseSalesmanSelect: {
        value: 'null',
        error: false,
      },
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      theadTh:{
        height: 40,
        paddingLeft: 10,
      },
      theadTh2:{
        height: 40,
        paddingLeft: 10,
        backgroundColor: '#eee'
      },
    }

  }

  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false) {
        this.getAgrupamentoUF();// Pega lista de AgrupamentoUFs
        this.getStates();// Pega a lista de estados
        this.getCurrentTimeServer();// Pega a data atual do servidor
        this.fullScreenModalFn();

        if (localStorage.getItem('planos_y') === 'BROKER')// Para perfil plataforma
          this.getSalesmanList();
        else
          this.getSalesman();;// Para perfil vendedor
      }
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  getSalesmanList() {
    // Pega os dados da plataforma
    axios.get(configBase.api + 'Brokers?filter={"where":{"userId":"'+localStorage.getItem('planos_u')+'"}}&access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      if (result.data && result.data.length > 0) {
        let filter = '{"where":{"brokerId":"'+result.data[0].id+'"},"include":"user"}&access_token='+localStorage.getItem('planos_t');

        // Pega a lista de vendedores
        axios.get(configBase.api + 'Salesmans?filter='+filter)
        .then((result2) => {
          let state = this.state;
          state.brokerId = result.data[0].id;
          state.listSalesman = result2.data;
          // Ordem alfabética
          state.listSalesman.sort(this.compare);
          this.setState(state);
        })
        .catch(function () {
          let state = this.state;
          state.showPage = false;
          this.setError('Problema encontrado ao buscar lista de vendedores');
        });
      }
      else {
        let state = this.state;
        state.showPage = false;
        this.setError('Plataforma não encontrada');
      }
    })
    .catch(function () {
      let state = this.state;
      state.showPage = false;
      this.setError('Problema encontrado ao buscar dados da plataforma');
    });
  }

  compare(a, b) {
    let aProposals = a.user.name;
    let bProposals = b.user.name;

    aProposals = aProposals.split(' - ');
    if (aProposals.length > 1)
      aProposals = aProposals[1];
    else
      aProposals = aProposals[0];

    bProposals = bProposals.split(' - ');
    if (bProposals.length > 1)
      bProposals = bProposals[1];
    else
      bProposals = bProposals[0];

    if (aProposals > bProposals)
      return 1;
    if (aProposals < bProposals)
      return -1;

    return 0;
  }

  salesmanChange(event) {
    let state = this.state;
    state.chooseSalesmanSelect.value = event.target.value;
    state.salesmanId = event.target.value;
    state.chooseSalesmanSelect.error = '';
    this.setState(state);
  }

  getAgrupamentoUF() {
    // Pega os agrupamentos
    axios.get(configBase.api + 'AgrupamentoUFs?access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      let state = this.state;

      if (result.data.length > 0) {
        state.localList = [];

        for (let i = 0; i < result.data.length; i++) {
          state.localList.push({
            value: result.data[i].abrangenciaId,
            label: result.data[i].agrupamento
          });
        }
      }

      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de Agrupamentos UF');
    }.bind(this));
  }

  localChange(e) {
    let state = this.state;
    state.localSelect = e.target.value;
    state.disabledLocalSelect = true;
    state.disabledPlansList = true;
    this.setState(state);

    let abrangenciaId = e.target.value

    axios.get(configBase.api + 'Plans?filter={"where":{"and":[{"abrangenciaId":"' + abrangenciaId + '"},{"publico":"Pessoa Jurídica"}]}}&access_token='+localStorage.getItem('planos_t'))
    .then((result) => {

      if (result.data.length > 0) {
        let state = this.state;
        state.disabledPlansList = false;
        state.plansFullList = result.data;
        state.planoTipoFaixa = true;
        state.plansList = [];
        state.disabledLocalSelect = false;

        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].abrangenciaId) {
            state.plansList.push({
              value: result.data[i].id,
              label: result.data[i].name + ' - ' + result.data[i].tipo
            });
          }
        }

        this.setState(state);
      }
      else {
        let state = this.state;
        state.disabledLocalSelect = false;
        state.disabledPlansList = true;
        this.setError('Planos não encontrados dentro desse local de utilização selecionado');
      }
    })
    .catch(function () {
      let state = this.state;
      state.disabledLocalSelect = false;
      state.disabledPlansList = true;
      this.setError('Problema encontrado ao buscar lista de Planos');
    }.bind(this));
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960) {
      state.fullScreenModal = false;
      state.orientationStepper = 'horizontal';
    }
    else {
      state.orientationStepper = 'vertical';
      state.fullScreenModal = true;
    }

    this.setState(state);
  }

  getStates() {
    // Pega a lista de estados
    axios.get(configBase.api + 'APIS4s/UFs?access_token='+localStorage.getItem('planos_t'))
    .then((result) => {
      let state = this.state;
      state.stateList = result.data;

      // Pega a lista de tipos de logradouros
      axios.get(configBase.api + 'APIS4s/tipoLogradouro?access_token='+localStorage.getItem('planos_t'))
      .then((result) => {
        state.addressTypeList = result.data;
        this.setState(state);
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar a lista dos tipos de logradouro');
      }.bind(this));
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de estados');
    }.bind(this));
  }

  getCurrentTimeServer() {
    // Pega a data atual do servidor
    axios.post(configBase.api + 'Sales/currentTime?access_token='+localStorage.getItem('planos_t'))
    .then((response) => {
      let state = this.state;
      state.currentTimeServer = response.data;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar data e hora corretos');
    }.bind(this));
  }

  getSalesman() {
    let filter = '{"where":{"userId":"'+localStorage.getItem('planos_u')+'"},"fields":{"brokerId":true,"id":true}}&access_token='+localStorage.getItem('planos_t');

    // Pega os dados do vendedor
    axios.get(configBase.api + 'Salesmans?filter='+filter)
    .then((result) => {
      if (result.data.length > 0) {
        let state = this.state;
        state.salesmanId = result.data[0].id;
        state.brokerId = result.data[0].brokerId;
        this.setState(state);
      }
    })
    .catch(function () {
      this.setError('Vendedor não encontrado');
    }.bind(this));
  }

  updateFieldStep1(event) {
    let state = this.state;
    state.fieldStep1[event.target.name].value = event.target.value;
    state.fieldStep1[event.target.name].error = '';
    this.setState(state);

    // Apenas letras
    if (state.fieldStep1[event.target.name].type === 'text')
      this.validateLetters(event.target.value, event.target.name, 'fieldStep1');
    else if (state.fieldStep1[event.target.name].type === 'number')
      this.validateNumber(state.fieldStep1[event.target.name].value, event.target.name, 'fieldStep1');

    if (event.target.name === 'cep')
      this.getAddress();
    else if (event.target.name === 'state')
      this.getCity(null);
    else if (event.target.name === 'city')
      this.beforeGetDistrict(null);
  }

  validateLetters(text, field, stepData) {
    let nameReg = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;

    if (text.length > 0) {
      if (!nameReg.test(text)) {
        let state = this.state;
        if (stepData === 'fieldStep1')
          state.fieldStep1[field].error = 'Apenas letras';
        else if (stepData === 'holder')
          state.holderList[state.holderIndex][field].error = 'Apenas letras';
        else if (stepData === 'dependent')
          state.holderList[state.holderIndex].dependents[state.dependentIndex][field].error = 'Apenas letras';

        this.setState(state);
      }
    }
  }

  validateNumber(number, field, stepData) {
    let numberReg = /^[0-9/ ]+$/;

    if (number.length > 0) {
      if(!numberReg.test(number)) {
        let state = this.state;
        if (stepData === 'fieldStep1')
          state.fieldStep1[field].error = 'Apenas números';
        else if (stepData === 'holder')
          state.holderList[state.holderIndex][field].error = 'Apenas números';
        else if (stepData === 'dependent')
          state.holderList[state.holderIndex].dependents[state.dependentIndex][field].error = 'Apenas números';

        this.setState(state);
      }
    }
  }

  validateCnpj() {
    let cnpj = this.state.fieldStep1.cnpj.value.replace(/[^\d]+/g, '');
    //let tamanho = cnpj.length - 2;
    //let numeros = cnpj.substring(0, tamanho);
    //let digitos = cnpj.substring(tamanho);
    //let soma = 0;
    //let pos = tamanho - 7;
    //let resultado = 0;
    let erro = false;

    if (cnpj === '')
      erro = true;

    if (cnpj.length !== 14)
      erro = true;

    if (cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999") {
        erro = true;
    }

    /* for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;

      if (pos < 2)
        pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado !== digitos.charAt(0))
      erro = true;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;

      if (pos < 2)
        pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado !== digitos.charAt(1))
      erro = true; */

    let state = this.state;

    if (erro === true) {
      state.fieldStep1.cnpj.error = 'CNPJ inválido';
      this.setState(state);
      return false;
    }
    else {
      state.fieldStep1.cnpj.error = '';
      this.setState(state);
      return true;
    }
  }

  validateTel(field) {
    let tel = this.state.fieldStep1[field].value;
    let telLength = tel.replace(/[^0-9]/g, '').length;

    if (telLength > 0) {
      if (telLength !== 10) {
        let state = this.state;
        state.fieldStep1[field].error = 'Número de telefone inválido';
        this.setState(state);
      }
    }
  }

  validateCell(field) {
    let tel = this.state.fieldStep1[field].value;
    let telLength = tel.replace(/[^0-9]/g, '').length;

    if (telLength > 0) {
      if (telLength !== 11) {
        let state = this.state;
        state.fieldStep1[field].error = 'Número de celular inválido';
        this.setState(state);
      }
    }
  }

  getAddress() {
    let valueCep = this.state.fieldStep1.cep.value.replace(/[^\d]+/g,"");

    if (valueCep.length >= 8) {
      let state = this.state;
      state.fieldStep1.addressNumber.error = '';
      state.fieldStep1.addressType.loading = true;
      state.fieldStep1.addressType.error = '';
      state.fieldStep1.address.loading = true;
      state.fieldStep1.address.error = '';
      state.fieldStep1.state.loading = true;
      state.fieldStep1.state.error = '';
      state.fieldStep1.city.loading = true;
      state.fieldStep1.city.error = '';
      state.fieldStep1.district.loading = true;
      state.fieldStep1.district.error = '';
      this.setState(state);

      let dataPost = {
        'cep': valueCep
      };

      axios.post(configBase.api + 'APIS4s/Endereco?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        if (result.data !== null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.fieldStep1.addressType.value = result.data.IdTipoLogradouro;
          state.fieldStep1.address.value = result.data.Logradouro;
          state.fieldStep1.state.value = result.data.IdUf;
          this.setState(state);

          this.getCity(function (stateCity) {
            stateCity.fieldStep1.city.value = result.data.IdMunicipio;
            this.setState(stateCity);

            this.beforeGetDistrict(function (stateDistrict) {
              stateDistrict.fieldStep1.district.value = result.data.IdBairro;

              state.fieldStep1.addressType.loading = false;
              state.fieldStep1.address.loading = false;
              state.fieldStep1.addressNumber.loading = false;
              state.fieldStep1.state.loading = false;
              state.fieldStep1.city.loading = false;
              state.fieldStep1.district.loading = false;
              this.setState(stateDistrict);
              document.getElementById('i_addressNumber').focus();
            }.bind(this));
          }.bind(this));
        }
        else {
          let state = this.state;
          state.fieldStep1.addressType.loading = false;
          state.fieldStep1.address.loading = false;
          state.fieldStep1.addressNumber.loading = false;
          state.fieldStep1.state.loading = false;
          state.fieldStep1.city.loading = false;
          state.fieldStep1.district.loading = false;
          state.fieldStep1.cep.error = '';

          state.fieldStep1.addressType.value = 'null';
          state.fieldStep1.address.value = '';
          state.fieldStep1.addressNumber.value = '0';
          state.fieldStep1.state.value = 'null';
          state.fieldStep1.city.value = 'null';
          state.fieldStep1.district.value = 'null';
          this.setError('CEP não encontrado');
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar endereço pelo CEP');
      }.bind(this));
    }
  }

  getCity(cb=null) {
    let state = this.state;
    state.fieldStep1.city.value = 'null';
    state.fieldStep1.district.value = 'null';
    this.setState(state);

    let chosenState = 0;
    chosenState = this.state.fieldStep1.state.value;

    if (cb === null) {
      let state = this.state;
      state.fieldStep1.city.loading = true;
      state.fieldStep1.district.loading = true;
      state.cityList = [];
      state.districtList = [];
      this.setState(state);
    }

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;

      if (cb !== null) {
        this.setState(state);
        cb(state);
      }
      else {
        state.fieldStep1.city.loading = false;
        state.fieldStep1.district.loading = false;
        this.setState(state);
      }
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado');
    }.bind(this));
  }

  beforeGetDistrict(cb=null) {
    let state = this.state;
    state.fieldStep1.district.value = 'null';
    this.setState(state);

    this.getDistrict(cb);
  }

  getDistrict(cb=null) {
    let chosenCity = 0;
    chosenCity = this.state.fieldStep1.city.value;

    if (cb === null) {
      let state = this.state;
      state.fieldStep1.district.loading = true;
      state.districtList = [];
      this.setState(state);
    }

    let dataPost = {
      idCity: parseInt(chosenCity)
    };

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;

      if (cb !== null) {
        this.setState(state);
        cb(state);
      }
      else {
        state.fieldStep1.district.loading = false;
        this.setState(state);
      }
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade');
    }.bind(this));
  }

  validateAllCpf(stepData, field) {
    let state = this.state;
    //let depIndex = this.state.depIndex;
    //let error = false;
    let cpf = '';

    if (stepData === 'fieldStep1')
      cpf = state.fieldStep1[field].value;

    if (cpf.replace(/[^\d]+/g,"") > 0) {
      if (this.validateCpf(cpf) === false) {
        if (stepData === 'fieldStep1') {
          state.fieldStep1[field].error = 'CPF inválido';
        }
      }
    }

    this.setState(state);
  }

  validateCpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g,"");
    let test = true;
    let add = 0, i = 0, rev = 0;
    if (cpf.length !== 11 || 
        cpf === "00000000000" || 
        cpf === "11111111111" || 
        cpf === "22222222222" || 
        cpf === "33333333333" || 
        cpf === "44444444444" || 
        cpf === "55555555555" || 
        cpf === "66666666666" || 
        cpf === "77777777777" || 
        cpf === "88888888888" || 
        cpf === "99999999999"){
      test = false;
    }
    else {
      for (i=0; i < 9; i ++)		
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev === 10 || rev === 11){		
          rev = 0;
        }	
        if (rev !== parseInt(cpf.charAt(9))){		
          test = false;          	
        }	
      add = 0;	
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }	
      rev = 11 - (add % 11);	
      if (rev === 10 || rev === 11){
        rev = 0;
      }	
      if (rev !== parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    if (test === true)
      return true;
    else
      return false;
  }

  dropzoneDialogOpen(typeFile=null) {
    let state = this.state;
    state.dropzoneDialog = true;

    if (typeFile !== null)
      state.typeFile = typeFile;

    this.setState(state);
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    let reader = new FileReader();
    let file = files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;

    document.getElementById('imagem_'+state.typeFile).value = "";
    state.imagesDocsUrl[state.typeFile].error = '';

    if (ext === 'pdf')
      state.imagesDocsUrl[state.typeFile].url = "pdf";
    else 
      state.imagesDocsUrl[state.typeFile].url = window.URL.createObjectURL(file);

    this.dropzoneDialogClose();
    
    reader.onloadend = function() {
      document.getElementById('imagem_'+state.typeFile).value = reader.result;
    };

    reader.readAsDataURL(file);
  }

  checkAccentuation(text) {
    let accentuationList = "áàãâäéèêëíìîïóòõôöúùûüÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜ";

    for (let i = 0; i < text.length; i++) {
      if (accentuationList.indexOf(text[i]) >= 0) {
        return false;
      }
    }

    return true;
  }

  calculateAge(anoAniv, mesAniv, diaAniv) {
    let anoAtual = this.state.currentTimeServer.year,
        mesAtual = this.state.currentTimeServer.month,
        diaAtual = this.state.currentTimeServer.day,
        qtsAnos = anoAtual - anoAniv;

    anoAniv = +anoAniv;
    mesAniv = +mesAniv;
    diaAniv = +diaAniv;

    if ((mesAtual < mesAniv || mesAtual === mesAniv) && diaAtual < diaAniv)
        qtsAnos--;

    return qtsAnos < 0 ? 0 : qtsAnos;
  }

  fileToBase64UsersTable(files) {
    let reader = new FileReader();
    let file = files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;

    document.getElementById('imagem_'+state.typeFile).value = "";
    state.imagesDocsUrl[state.typeFile].error = '';
    state.imagesDocsUrl[state.typeFile].url = window.URL.createObjectURL(file);
    state.msgUsersTable = '';
    this.setState(state);

    this.dropzoneDialogClose();

    reader.onloadend = function() {
      document.getElementById('imagem_'+state.typeFile).value = reader.result;

      if (ext === 'xlsx') {
        readXlsxFile(file).then((rows) => {
          this.setState(state);

          // Planilha vazia
          if (rows.length <= 3) {
            state.typeMsgUsersTable = 'error';
            state.msgUsersTable = 'PLANILHA VAZIA - FAVOR PREENCHER ANTES DE ENVIAR';
            document.getElementById('i_msgUsersTable').scrollIntoView();
            document.getElementById('imagem_'+state.typeFile).value = "";
          }
          else {
            let nomeTit = 0;
            let nomeDep = 1;
            let cpf = 2;
            let dataNasc = 3;
            let tipoPlano = 4;
            let nomeMae = 5;
            let sexo = 6;
            let rg = 7;
            let emissaoRg = 8;
            let celular = 9;

            for (let i = 3; i < rows.length; i++) {
              if (rows[i][nomeTit] === null && rows[i][nomeDep] === null) {
                state.typeMsgUsersTable = 'error';
                state.msgUsersTable = 'FUNCIONÁRIO SEM NOME DE TITULAR E SEM NOME DE DEPENDENTE';
                document.getElementById('i_msgUsersTable').scrollIntoView();
                document.getElementById('imagem_'+state.typeFile).value = "";
                break;
              }

              if (rows[i][tipoPlano] === null) {
                state.typeMsgUsersTable = 'error';
                state.msgUsersTable = 'O TIPO DE PLANO É OBRIGATÓRIO PARA TITULARES E DEPENDENTES';
                document.getElementById('i_msgUsersTable').scrollIntoView();
                document.getElementById('imagem_'+state.typeFile).value = "";
                break;
              }
              else {
                let tipoPlanoList = ['clínico', 'clinico', 'orto'];
                // Não é um tipo de plano válido
                if (tipoPlanoList.indexOf(rows[i][tipoPlano].toLowerCase()) < 0) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][tipoPlano] + ' - NÃO É UM TIPO DE PLANO VÁLIDO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }
              }

              // Linha do titular
              if (rows[i][nomeTit] !== null && rows[i][nomeDep] === null) {
                // Verifica nome completo
                if (rows[i][nomeTit].indexOf('.') >= 0) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Nome com acentuação
                if (this.checkAccentuation(rows[i][nomeTit]) === false) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - NOME COMPLETO SEM ACENTUAÇÃO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Sem CPF
                if (rows[i][cpf] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM CPF INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Sem RG
                if (rows[i][rg] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM RG INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Sem orgão expedidor do RG
                if (rows[i][emissaoRg] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM ORGÃO EXPEDIDOR DO RG INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Sem data de nascimento
                if (rows[i][dataNasc] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }
                // Titular maior ou igual a 18 anos
                else {
                  let age = new Date(rows[i][dataNasc]);
                  if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) < 18 ) {
                    state.typeMsgUsersTable = 'error';
                    state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - DEVERÁ SER MAIOR DE IDADE (18 ANOS)';
                    document.getElementById('i_msgUsersTable').scrollIntoView();
                    document.getElementById('imagem_'+state.typeFile).value = "";
                    break;
                  }
                }

                // Sem nome da mãe
                if (rows[i][nomeMae] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Sem sexo
                if (rows[i][sexo] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM SEXO INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }
                else {
                  if (rows[i][sexo].toUpperCase() !== 'M' && rows[i][sexo].toUpperCase() !== 'F') {
                    state.typeMsgUsersTable = 'error';
                    state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - COM SEXO INVÁLIDO. ACEITO: F/M';
                    document.getElementById('i_msgUsersTable').scrollIntoView();
                    document.getElementById('imagem_'+state.typeFile).value = "";
                    break;
                  }
                }

                // Sem celular
                if (rows[i][celular] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeTit].toUpperCase()+' - SEM CELULAR INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

              }// Fim titular
              // Linha dos dependentes
              else {
                // Verifica acentuação
                if (rows[i][nomeDep].indexOf('.') >= 0) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Nome com acentuação
                if (this.checkAccentuation(rows[i][nomeDep]) === false) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }
                
                // Sem data de nascimento
                if (rows[i][dataNasc] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }
                else {
                  // Apartir de 10 anos CPF obrigatório
                  let age = new Date(rows[i][dataNasc]);
                  if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) >= 10 && rows[i][cpf] === null) {
                    state.typeMsgUsersTable = 'error';
                    state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - A PARTIR DE 10 ANOS CPF OBRIGATÓRIO';
                    document.getElementById('i_msgUsersTable').scrollIntoView();
                    document.getElementById('imagem_'+state.typeFile).value = "";
                    break;
                  }
                }

                // Sem nome da mãe
                if (rows[i][nomeMae] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }

                // Sem sexo
                if (rows[i][sexo] === null) {
                  state.typeMsgUsersTable = 'error';
                  state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - SEM SEXO INFORMADO';
                  document.getElementById('i_msgUsersTable').scrollIntoView();
                  document.getElementById('imagem_'+state.typeFile).value = "";
                  break;
                }
                else {
                  if (rows[i][sexo].toUpperCase() !== 'M' && rows[i][sexo].toUpperCase() !== 'F') {
                    state.typeMsgUsersTable = 'error';
                    state.msgUsersTable = rows[i][nomeDep].toUpperCase()+' - COM SEXO INVÁLIDO. ACEITO: F ou M';
                    document.getElementById('i_msgUsersTable').scrollIntoView();
                    document.getElementById('imagem_'+state.typeFile).value = "";
                    break;
                  }
                }

              }// Fim dependentes

            }// Fim for

          }

          this.setState(state);
        });
      }
      else {
        let state = this.state;
        state.imagesDocsUrl.usersTable.url = '';
        state.imagesDocsUrl.usersTable.error = 'APENAS ARQUIVOS DO TIPO .xlsx';
        this.setState(state);
      }
    }.bind(this);

    reader.readAsDataURL(file);
  }

  checkChange(event) {
    let state = this.state;

    if (event.target.name === 'checkFile') {
      if (state.checkFile === false) {
        state.checkFile = event.target.checked;
        state.checkForm = !event.target.checked;
      }
    }
    else {
      if (state.checkForm === false) {
        state.checkForm = event.target.checked;
        state.checkFile = !event.target.checked;
      }
    }

    this.setState(state);
  }

  modalAddHolderFn() {
    let state = this.state;
    state.modalAddHolder = !state.modalAddHolder;

    if (state.modalAddHolder === false) {
      state.isHolderEdit = false;
      state.holderIndex = state.holderList.length - 1;
    }

    this.setState(state);
  }

  updateFieldsModalForm(type, event) {
    /*
     * @type - Pode ser 'holder' ou 'dependent'
    */

    let state = this.state;

    if (type === 'holder') {
      state.holderList[state.holderIndex][event.target.name].value = event.target.value;
      state.holderList[state.holderIndex][event.target.name].error = '';

      // Apenas letras
      if (state.holderList[state.holderIndex][event.target.name].type === 'text')
        this.validateLetters(event.target.value, event.target.name, 'holder');
      // Apenas Números
      else if (state.holderList[state.holderIndex][event.target.name].type === 'number')
        this.validateNumber(event.target.value, event.target.name, 'holder');
    }
    else {
      state.holderList[state.holderIndex].dependents[state.dependentIndex][event.target.name].value = event.target.value;
      state.holderList[state.holderIndex].dependents[state.dependentIndex][event.target.name].error = '';

      // Apenas letras
      if (state.holderList[state.holderIndex].dependents[state.dependentIndex][event.target.name].type === 'text')
        this.validateLetters(event.target.value, event.target.name, 'dependent');
      // Apenas Números
      else if (state.holderList[state.holderIndex].dependents[state.dependentIndex][event.target.name].type === 'number')
        this.validateNumber(event.target.value, event.target.name, 'dependent');
    }

    this.setState(state);
  }

  verifyCPFModalForm(type) {
    /*
     * @type - Pode ser 'holder' ou 'dependent'
    */

    let cpf = '';

    if (type === 'holder')
      cpf = this.state.holderList[this.state.holderIndex].cpf.value.replace(/[^\d]+/g,"");
    else
      cpf = this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cpf.value.replace(/[^\d]+/g,"");

    if (this.validateCpf(cpf) === false) {
      let state = this.state;
      
      if (type === 'holder')
        state.holderList[state.holderIndex].cpf.error = 'CPF inválido';
      else
        state.holderList[state.holderIndex].dependents[state.dependentIndex].cpf.error = 'CPF inválido';

      this.setState(state);
    }
  }

  verifyEmailModalForm(type) {
    /*
     * @type - Pode ser 'holder' ou 'dependent'
    */

    let email = '';

    if (type === 'holder')
      email = this.state.holderList[this.state.holderIndex].email.value;
    else
      email = this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].email.value;

    if (email.length > 0) {
      if (this.validateEmail(email) === false) {
        let state = this.state;
        
        if (type === 'holder')
          state.holderList[state.holderIndex].email.error = 'E-mail inválido';
        else
          state.holderList[state.holderIndex].dependents[state.dependentIndex].email.error = 'E-mail inválido';
  
        this.setState(state);
      }
    }

  }

  validateEmail(email) {
    let emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if(!emailReg.test(email) || email === ""){
      return false;
    }else{
      return true;
    }
  }

  updateFieldDate(type, field, value) {
    /*
     * @type - Pode ser 'holder' ou 'dependent'
    */

    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    if (type === 'dependent')
      state.holderList[state.holderIndex].dependents[state.dependentIndex][field].error = '';
    else
      state.holderList[state.holderIndex][field].error = '';

    this.setState(state);

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      if (value.getTime() !== 0) {
        day = value.getDate();
        month = value.getMonth() + 1;
        year = value.getFullYear();;

        if (day < 10)
          day = '0'+ day;
        if (month < 10)
          month = '0'+ month;

        if (type === 'dependent')
          state.holderList[state.holderIndex].dependents[state.dependentIndex][field].value = year+'-'+month+'-'+day;
        else
          state.holderList[state.holderIndex][field].value = year+'-'+month+'-'+day;

        this.validateDate(day+'/'+month+'/'+year, field, type);
      }
      else {
        if (type === 'dependent') {
          state.holderList[state.holderIndex].dependents[state.dependentIndex][field].value = value;
          state.holderList[state.holderIndex].dependents[state.dependentIndex][field].error = 'Data inválida';
        }
        else {
          state.holderList[state.holderIndex][field].value = value;
          state.holderList[state.holderIndex][field].error = 'Data inválida';
        }
      }
    }
    else {
      if (type === 'dependent') {
        state.holderList[state.holderIndex].dependents[state.dependentIndex][field].value = value;
        state.holderList[state.holderIndex].dependents[state.dependentIndex][field].error = 'Data inválida';
      }
      else {
        state.holderList[state.holderIndex][field].value = value;
        state.holderList[state.holderIndex][field].error = 'Data inválida';
      }
    }

    this.setState(state);
  }

  validateDate(date, field, stepData) {
    let dateReg = /^((((0?[1-9]|[12]\d|3[01])[.\-/](0?[13578]|1[02])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[.\-/](0?[13456789]|1[012])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|(29[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    if (date.length > 0) {
      if(!dateReg.test(date)) {
        let state = this.state;

        if (stepData === 'dependent')
          state.holderList[state.holderIndex].dependents[state.dependentIndex][field].error = 'Data inválida';
        else
          state.holderList[state.holderIndex][field].error = 'Data inválida';

        this.setState(state);
      }
    }
  }

  verifyAddHolder() {
    let state = this.state;
    let error = false;
    let holder = state.holderList[state.holderIndex];
    let depListTemp = state.holderList[state.holderIndex].dependents;

    delete holder['dependents'];

    Object.keys(holder).forEach(function(key) {
      if (holder[key].error.length === 0) {
        // Verifica campos obrigatórios
        if (holder[key].required === true) {
          if (holder[key].value !== null) {
            if (holder[key].value.toString().replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/g, "").replace('null', '').length === 0) {
              state.holderList[state.holderIndex][key].error = "Obrigatório";
              error = true;
            }
          }
          else {
            state.holderList[state.holderIndex][key].error = "Obrigatório";
            error = true;
          }
        }
      }
      else
        error = true;
    });

    state.holderList[state.holderIndex]['dependents'] = depListTemp;

    if (error === false) {
      this.setHolderDefault();
      this.setValueTotal();
      this.modalAddHolderFn();
    }
    else
      this.setError('Campos com erro');
  }

  setValueTotal() {
    let state = this.state;
    // Total de titulares
    state.totalHolder = state.holderList.length - 1;
    state.totalDependents = 0;
    state.totalBeneficiaries = 0;
    // Zera o valor total
    state.value_total = '0.00';

    // Loop nos planos disponívels para essa empresa para cáculo do total de beneficiários
    for (let i = 0; i < state.fieldStep1.plansListChosen.value.length; i++) {
      // Zera o valor atual de beneficiários
      state.fieldStep1.plansListChosen.value[i].holderTotal = 0;
      state.fieldStep1.plansListChosen.value[i].dependentTotal = 0;
      // Loop nos titulares para somar a quantidade de beneficiários
      for (let j = 0; j < state.holderList.length - 1; j++) {
        // Se o plano do titular for igual a um dos planos disponíveis
        if (state.holderList[j].plansId.value === state.fieldStep1.plansListChosen.value[i].id) {
          // Soma o total de beneficiários para esse plano
          state.fieldStep1.plansListChosen.value[i].holderTotal = state.fieldStep1.plansListChosen.value[i].holderTotal + 1;
        }

        // Loop nos dependentes para somar a quantidade de beneficiários
        for (let m = 0; m < state.holderList[j].dependents.length - 1; m++) {
          // Se o plano do dependente for igual a um dos planos disponíveis
          if (state.holderList[j].dependents[m].plansId.value === state.fieldStep1.plansListChosen.value[i].id) {
            // Soma o total de beneficiários para esse plano
            state.fieldStep1.plansListChosen.value[i].dependentTotal = state.fieldStep1.plansListChosen.value[i].dependentTotal + 1;
          }
        }
      }

      state.totalDependents = state.totalDependents + state.fieldStep1.plansListChosen.value[i].dependentTotal;
      state.totalBeneficiaries = state.totalBeneficiaries +
                                 state.fieldStep1.plansListChosen.value[i].holderTotal + 
                                 state.fieldStep1.plansListChosen.value[i].dependentTotal;
    }

    // Loop nos planos disponívels para essa empresa para o cálculo dos valores
    for (let i = 0; i < state.fieldStep1.plansListChosen.value.length; i++) {
      // Zera o valor total
      state.fieldStep1.plansListChosen.value[i].dependentValueTotal = 0;
      // Loop nos titulares para somar os valores
      for (let j = 0; j < state.holderList.length - 1; j++) {
        // Se o plano do titular for igual a um dos planos disponíveis
        if (state.holderList[j].plansId.value === state.fieldStep1.plansListChosen.value[i].id) {
          // Loop nas faixas de valores do plano
          for (let z = 0; z < state.fieldStep1.plansListChosen.value[i].valores.length; z++) {
            // Verifica a faixa que a empresa se enquadra
            if ((state.totalBeneficiaries >= state.fieldStep1.plansListChosen.value[i].valores[z].qtdInicial) &&
                (state.totalBeneficiaries <= state.fieldStep1.plansListChosen.value[i].valores[z].qtdFinal)) {
              // Zera o valor total
              state.fieldStep1.plansListChosen.value[i].holderValueTotal = 0;

              state.fieldStep1.plansListChosen.value[i].holderValueTotal = state.fieldStep1.plansListChosen.value[i].holderTotal *
                        parseFloat(state.fieldStep1.plansListChosen.value[i].valores[z].valorTitular.replace(',', '.'));
            }
          }
        }

        // Loop nos dependentes para somar os valores
        for (let m = 0; m < state.holderList[j].dependents.length - 1; m++) {
          // Se o plano do dependente for igual a um dos planos disponíveis
          if (state.holderList[j].dependents[m].plansId.value === state.fieldStep1.plansListChosen.value[i].id) {
            // Loop nas faixas de valores do plano
            for (let z = 0; z < state.fieldStep1.plansListChosen.value[i].valores.length; z++) {
              // Verifica a faixa que a empresa se enquadra
              if ((state.totalBeneficiaries >= state.fieldStep1.plansListChosen.value[i].valores[z].qtdInicial) &&
                (state.totalBeneficiaries <= state.fieldStep1.plansListChosen.value[i].valores[z].qtdFinal)) {
                // Zera o valor total
                state.fieldStep1.plansListChosen.value[i].dependentValueTotal = 0;

                state.fieldStep1.plansListChosen.value[i].dependentValueTotal = state.fieldStep1.plansListChosen.value[i].dependentTotal *
                        parseFloat(state.fieldStep1.plansListChosen.value[i].valores[z].valorDependente.replace(',', '.'));
              }
            }
          }
        }
      }

      // Caso já exista o valor para o titular
      if (state.fieldStep1.plansListChosen.value[i].holderValueTotal)
        state.value_total = (parseFloat(state.value_total.replace(',', '.')) + state.fieldStep1.plansListChosen.value[i].holderValueTotal).toFixed(2).replace('.', ',');

      // Caso já exista o valor para o dependente
      if (state.fieldStep1.plansListChosen.value[i].dependentValueTotal)
        state.value_total = (parseFloat(state.value_total.replace(',', '.')) + state.fieldStep1.plansListChosen.value[i].dependentValueTotal).toFixed(2).replace('.', ',');
    }

    this.setState(state);
  }

  setHolderDefault() {
    if (this.state.isHolderEdit === false) {
      let state = this.state;

      state.holderIndex = state.holderIndex + 1;

      state.holderList.push({
        firstName: {value: '', required: true, error: '', model: 'holder', type: 'text'},
        cpf: {value: '', required: true, error: '', model: 'holder', type: ''},
        email: {value: '', required: false, error: '', model: 'holder', type: 'email'},
        cellPhone: {value: '', required: true, error: '', model: 'holder', type: ''},
        rg: {value: '', required: true, error: '', model: 'holder', type: 'number'},
        rgEmitter: {value: '', required: true, error: '', model: 'holder', type: 'text'},
        dateOfBirth: {value: null, required: true, error: '', model: 'holder', type: 'date'},
        motherName: {value: '', required: true, error: '', model: 'holder', type: 'text'},
        gender: {value: 'null', required: true, error: '', model: 'holder', type: ''},
        plansId: {value: 'null', required: true, error: '', model: 'holder', type: ''},
        susNumber: {value: '', required: false, error: '', model: 'holder', type: 'number'},
        dependents: [
          {
            firstName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
            cpf: {value: '', required: true, error: '', model: 'dependent', type: ''},
            email: {value: '', required: false, error: '', model: 'dependent', type: 'email'},
            cellPhone: {value: '', required: true, error: '', model: 'dependent', type: ''},
            rg: {value: '', required: true, error: '', model: 'dependent', type: 'number'},
            rgEmitter: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
            dateOfBirth: {value: null, required: true, error: '', model: 'dependent', type: 'date'},
            motherName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
            gender: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
            parentage: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
            plansId: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
            susNumber: {value: '', required: false, error: '', model: 'dependent', type: 'number'},
          }
        ],
      });

      this.setState(state);
    }
    else {
      let state = this.state;
      state.isHolderEdit = false;
      state.holderIndex = state.holderList.length - 1;
      this.setState(state);
      this.modalAddHolderFn();
    }
  }

  modalConfirmRemoveHolderOpen(index) {
    let state = this.state;
    state.modalConfirmRemoveHolder = true;
    state.holderDeleteIndex = index;
    this.setState(state);
  }

  modalConfirmRemoveHolderClose() {
    let state = this.state;
    state.modalConfirmRemoveHolder = false;
    state.holderDeleteIndex = 0;
    this.setState(state);
  }

  removeHolder() {
    let state = this.state;
    state.holderList.splice(this.state.holderDeleteIndex, 1);
    state.holderIndex = state.holderList.length - 1;
    this.setState(state);

    this.modalConfirmRemoveHolderClose();
    this.setValueTotal();
  }

  editHolder(index) {
    let state = this.state;
    state.isHolderEdit = true;
    state.holderIndex = index;
    this.setState(state);

    this.modalAddHolderFn();
  }

  verificaIsDependentEdit(indexHold, indexDep = null){
    let state = this.state;
    state.isDependentEdit = false
    this.setState(state);
    this.modalAddDependentOpen(indexHold, indexDep)
  }

  modalAddDependentOpen(indexHold, indexDep = null) {
    let state = this.state;
    state.modalAddDependent = true;
    state.holderIndex = indexHold;

    if(indexDep === null)
      state.dependentIndex = state.holderList[indexHold].dependents.length - 1;
    else
      state.dependentIndex = indexDep;

    this.setState(state);
  }

  modalAddDependentClose() {
    let state = this.state;
    state.modalAddDependent = false;
    state.holderIndex = state.holderList.length - 1;
    state.dependentIndex = state.holderList[state.holderIndex].dependents.length - 1;
    this.setState(state);
  }

  verifyAddDependent() {
    let state = this.state;
    let error = false;
    let dep = state.holderList[state.holderIndex].dependents[state.dependentIndex];

    Object.keys(dep).forEach(function(key) {
      if (dep[key].error.length === 0) {
        // Verifica campos obrigatórios
        if (dep[key].required === true) {
          if (dep[key].value !== null) {
            if (dep[key].value.toString().replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/g, "").replace('null', '').length === 0) {
              state.holderList[state.holderIndex].dependents[state.dependentIndex][key].error = "Obrigatório";
              error = true;
            }
          }
          else {
            state.holderList[state.holderIndex].dependents[state.dependentIndex][key].error = "Obrigatório";
            error = true;
          }
        }
      }
      else
        error = true;
    });

    if (error === false) {
      this.setDependentDefault();
      this.setValueTotal();
      state.isDependentEdit = false;
      this.setState(state);
      this.modalAddDependentClose();
    }
    else
      this.setError('Campos com erro');
      state.isDependentEdit = true;
      this.setState(state);
  }

  modalConfirmRemoveDependentOpen(indexDep, indexHol) {
    let state = this.state;
    state.modalConfirmRemoveDependent = true;
    state.dependentDeleteIndex = indexDep;
    state.holderIndex = indexHol;
    this.setState(state);
  }

  modalConfirmRemoveDependentClose() {
    let state = this.state;
    state.modalConfirmRemoveDependent = false;
    this.setState(state);
  }

  removeDependent() {
    let state = this.state;
    state.holderList[state.holderIndex].dependents.splice(this.state.dependentDeleteIndex, 1);
    state.holderIndex = state.holderList.length - 1;
    state.dependentIndex = state.holderList[state.holderIndex].dependents.length - 1;
    state.dependentDeleteIndex = 0;
    this.setState(state);

    this.modalConfirmRemoveDependentClose();
    this.setValueTotal();
  }

  editDependent(indexDep, indexHol) {
    let state = this.state;
    state.isDependentEdit = true;
    state.holderIndex = indexHol;
    state.dependentIndex = indexDep;
    this.setState(state);
    this.modalAddDependentOpen(indexHol, indexDep);
  }

  setDependentDefault() {
    if (this.state.isDependentEdit === false) {
      let state = this.state;

      state.holderList[state.holderIndex].dependents.push({
        firstName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
        cpf: {value: '', required: true, error: '', model: 'dependent', type: ''},
        email: {value: '', required: false, error: '', model: 'dependent', type: 'email'},
        cellPhone: {value: '', required: true, error: '', model: 'dependent', type: ''},
        rg: {value: '', required: true, error: '', model: 'dependent', type: 'number'},
        rgEmitter: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
        dateOfBirth: {value: null, required: true, error: '', model: 'dependent', type: 'date'},
        motherName: {value: '', required: true, error: '', model: 'dependent', type: 'text'},
        gender: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
        parentage: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
        plansId: {value: 'null', required: true, error: '', model: 'dependent', type: ''},
        susNumber: {value: '', required: false, error: '', model: 'dependent', type: 'number'},
      });

      state.dependentIndex = state.holderList[state.holderIndex].dependents.length - 1;
      this.setState(state);
    }
    else {
      let state = this.state;
      state.isDependentEdit = false;
      state.holderIndex = state.holderList.length - 1;
      state.dependentIndex = state.holderList[state.holderIndex].dependents - 1;
      this.setState(state);
      this.modalAddDependentOpen(state.holderIndex, null);
    }
  }

  addPlansListChosen() {
    let state = this.state;

    for (let i = 0; i < this.state.plansList.length; i++) {
      if (this.state.plansList[i].value === this.state.plansSelectedId.value) {
        state.plansList.splice(i, 1);
        break;
      }
    }

    for (let i = 0; i < this.state.plansFullList.length; i++) {
      if (this.state.plansFullList[i].id === this.state.plansSelectedId.value) {
        state.fieldStep1.plansListChosen.value.push(this.state.plansFullList[i]);
        state.fieldStep1.plansListChosen.error = '';
        state.plansSelectedId.value = 'null';
        break;
      }
    }

    this.setState(state);
  }

  modalConfirmRemovePlanOpen(index) {
    let state = this.state;
    state.modalConfirmRemovePlan = true;
    state.planRemoveIndex = index;
    this.setState(state);
  }

  modalConfirmRemovePlanClose() {
    let state = this.state;
    state.modalConfirmRemovePlan = false;
    state.planRemoveIndex = 0;
    this.setState(state);
  }

  removePlan() {
    let state = this.state;
    let index = state.planRemoveIndex;

    state.plansList.push({
      value: state.fieldStep1.plansListChosen.value[index].id,
      label: state.fieldStep1.plansListChosen.value[index].name + ' - ' + state.fieldStep1.plansListChosen.value[index].tipo
    });

    state.fieldStep1.plansListChosen.value.splice(index, 1);
    state.plansSelectedId.value = 'null';
    this.setState(state);
    this.modalConfirmRemovePlanClose();
  }

  showButtons(step=null) {
    let state = this.state;

    if (step !== null)
      state.stepper = this.state.stepper;

    if (state.stepper >= 1) {
      if (state.stepper === 1) {// Passo 2
        state.showButtonBack = true;
        state.showButtonFinished = false;
        state.showButtonNext = true;
        state.showButtonPrint = false;
      }
      else if (state.stepper === 2) {// Passo 3
        state.showButtonBack = true;
        state.showButtonFinished = false;
        state.showButtonNext = true;
        state.showButtonPrint = false;
      }
      else if (state.stepper === 3) {// Passo 4
        state.showButtonBack = true;
        state.showButtonFinished = true;
        state.showButtonNext = false;
        state.showButtonPrint = false;
      }
    }
    else {// Passo 1
      state.showButtonBack = false;
      state.showButtonFinished = false;
      state.showButtonNext = true;
      state.showButtonPrint = false;
    }

    this.setState(state);
  }

  /* backStep() {
    let state = this.state;
    state.stepper = state.stepper - 1;
    this.showButtons(state.stepper);
    this.setState(state);
  } */

  nextStep() {
    let state = this.state;
    let error = false;

    // Se o usuário for do perfil plataforma
    if (localStorage.getItem('planos_y') === 'BROKER') {
      if (this.state.chooseSalesmanSelect.value === 'null') {
        state.chooseSalesmanSelect.error = 'Por favor, escolher o vendedor';
        error = true;
      }
    }

    if (error === false) {
      if (state.stepper === 0)// Do passo 1 para o passo 2
        this.checkFieldStep1();
      else if (state.stepper === 1)// Do passo 2 para o passo 3
        this.checkFieldStep2();
      else if (state.stepper === 2)// Do passo 3 para o passo 4
        this.checkFieldStep3();
      else
        this.showButtons(null);
    }

    this.setState(state);
  }

  checkFieldStep1() {
    let data = this.state.fieldStep1;
    let error = false;
    let valueLength = 0;
    let state = this.state;
    state.loadingButtonNext = true;
    this.setState(state);

    // Verifica obrigatoriedade
    Object.keys(data).forEach(function(key) {
      if (state.fieldStep1[key].error.length === 0) {
        if (data[key].required === true) {
          if (data[key].value !== null) {
            if (key === 'plansListChosen')
              valueLength = data[key].value.length;
            else
              valueLength = data[key].value.toString().replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/g, "").replace('null', '').length;

            if (valueLength === 0) {
                state.fieldStep1[key].error = "Obrigatório";
                error = true;
            }
          }
          else {
            state.fieldStep1[key].error = "Obrigatório";
            error = true;
          }
        }
      }
      else
        error = true;
    });

    if (error === false) {
      state.stepper = state.stepper + 1;
      this.showButtons(state.stepper);
      this.saveCompany('');
    }
    else {
      let state = this.state;
      state.loadingButtonNext = false;
      this.setState(state);
      this.setError('Campos com erro');
    }

    this.setState(state);
  }

  saveCompany(status='') {
    // Para salvar a company
    let dataPost = {
      cnpj: this.state.fieldStep1.cnpj.value,
      fantasyName: this.state.fieldStep1.fantasyName.value,
      businessName: this.state.fieldStep1.businessName.value,
      cep: this.state.fieldStep1.cep.value,
      state: this.state.fieldStep1.state.value,
      city: this.state.fieldStep1.city.value,
      addressType: this.state.fieldStep1.addressType.value,
      address: this.state.fieldStep1.address.value,
      addressNumber: this.state.fieldStep1.addressNumber.value,
      addressComplement: this.state.fieldStep1.addressComplement.value,
      district: this.state.fieldStep1.district.value,
      homePhone: this.state.fieldStep1.homePhone.value,
      cellPhone: this.state.fieldStep1.cellPhone.value,
      cellPhone2: this.state.fieldStep1.cellPhone2.value,
      legalResponsible: this.state.fieldStep1.legalResponsible.value,
      legalResponsibleCpf: this.state.fieldStep1.legalResponsibleCpf.value,
      infoEmailInvoice: this.state.fieldStep1.infoEmailInvoice.value,
      chanelConfirm: 'EMAIL',
      salesmanId: this.state.salesmanId,
      brokerId: this.state.brokerId,
      status: "NOVAS",
      includesOrto: false,
      stageForm: this.state.stepper + 1,
      amountHolder: this.state.totalHolder,
      amountDependent: this.state.totalDependents,
      responsibility: this.state.value_total.replace(',', '.'),
      situacaoBoleto: '',
      nossoNumero: '',
      modalidadePagamento: '',
      vencimentoBoleto: '',
      reteveAdesao: this.state.fieldStep1.reteveAdesao.value,
      originRegister: 'INTERNO',
      /* legalResponsibleRg: '',
      legalResponsibleEmail: '',
      infoWorkerName: '',
      infoEmailContact: '',
      infoHomePhone: '',
      infoCellPhone: '',
      infoPersonInCharge: '',
      infoPersonInChargePhone: '',
      effectiveDate: '',
      effectiveDateMonth: '',
      effectiveDateYear: '',
      monthlyExpiration: '',
      cuttingDay: '',
      typeOfContract: '',
      amountUsers: '',
      costCenterS4: '',
      justifyValue: '',
      amountOrto: '',
      planS4: '',
      valuePlanOrto: '', */
    };

    if (status !== '')
      dataPost.status = status;

    // Salva a company pela primeira vez
    if (this.state.companyId === null) {
      axios.post(configBase.api + 'Companies?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        let state = this.state;
        state.loadingButtonNext = false;
        state.companyId = result.data.id;
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.loadingButtonNext = false;
        this.setState(state);
        this.setError('Problema encontrado ao salvar empresa');
      }.bind(this));
    }
    else {
      dataPost.id = this.state.companyId;

      if (!this.state.proposalNumber)
        dataPost.proposalNumber = parseInt(this.state.companyId.toString().replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10));

      axios.put(configBase.api + 'Companies?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        let state = this.state;
        state.companyId = result.data.id;
        state.loadingButtonNext = false;
        state.proposalNumber = result.data.proposalNumber;
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.loadingButtonNext = false;
        this.setState(state);
        this.setError('Problema encontrado ao salvar empresa');
      }.bind(this));
    }
  }

  checkFieldStep2() {
    if (this.state.checkFile === false && this.state.checkForm === false) {
      let state = this.state;
      state.loadingButtonNext = false;
      this.setState(state);
      this.setError('É necessário escolher um tipo de Formas de Inclusão');
    }
    else {
      // Para a escolha de inserir pelo formulário
      if (this.state.checkForm === true) {
        // Caso não tenha beneficiários cadastrados
        if (this.state.totalBeneficiaries === 0) {
          let state = this.state;
          state.loadingButtonNext = false;
          this.setState(state);
          this.setError('É necessário cadastrar os beneficiários');
        }
        else {
          let plans = this.state.fieldStep1.plansListChosen.value;
          let message = '';

          for (let i = 0; i < plans.length; i++) {
            // Verifica se a quantidade de beneficiários se enquadra na menor faixa de preços
            //if ((this.state.totalBeneficiaries >= plans[i].valores[0].qtdInicial) && (this.state.totalBeneficiaries <= plans[i].valores[0].qtdFinal))
            if (this.state.totalBeneficiaries < plans[i].valores[0].qtdInicial) {
              message = 'Quantidade de beneficiários insuficiente para o plano ' +
                        plans[i].codeS4 + ' - '+ plans[i].name + '. Mínimo: ' + plans[i].valores[0].qtdInicial;
              break;
            }
          }

          if (message.length > 0) {
            let state = this.state;
            state.loadingButtonNext = false;
            this.setState(state);
            this.setError(message);
          }
          else {// Salva o preço plano
            let state = this.state;
            state.loadingButtonNext = false;
            this.setState(state);

            this.savePrecoPlano();
          }
        }
      }

      // Para a escolha de inserir pela planilha
      else if (this.state.checkFile === true) {
        if (this.state.imagesDocsUrl.usersTable.url.length === 0) {
          let state = this.state;
          state.loadingButtonNext = false;
          this.setState(state);
          this.setError('É necessário anexar planilha preenchida com beneficiários');
        }
        else {
          if (this.state.imagesDocsUrl.usersTable.error.length > 0) {
            let state = this.state;
            state.loadingButtonNext = false;
            this.setState(state);
            this.setError('A planilha de beneficiários contém erro');
          }
          else {
            let state = this.state;
            state.stepper = state.stepper + 1;
            state.loadingButtonNext = false;
            this.setState(state);
            this.showButtons(state.stepper);
          }
        }
      }
    }
  }

  savePrecoPlano() {
    let state = this.state;
    let plans = state.fieldStep1.plansListChosen.value;
    let precoPlanoList = [];

    for (let i = 0; i < plans.length; i++) {
      // Para operadores do tipo faixa de preço
      if (this.state.planoTipoFaixa === true) {
        for (let z = 0; z < plans[i].valores.length; z++) {
          if ((state.totalBeneficiaries >= plans[i].valores[z].qtdInicial) && (state.totalBeneficiaries <= plans[i].valores[z].qtdFinal)) {
            precoPlanoList.push({
              valorTitular: plans[i].valores[z].valorTitular,
              valorDependente: plans[i].valores[z].valorDependente,
              valorAgregado: plans[i].valores[z].valorAgregado,
              companyId: this.state.companyId,
              plansId: plans[i].id,
            });
          }
        }
      }
    }

    axios.post(configBase.api + 'PrecoPlanos?access_token='+localStorage.getItem('planos_t'), precoPlanoList)
    .then(() => {
      this.saveHolderAndDependents(0);
    })
    .catch(function () {
      let state = this.state;
      state.loadingButtonNext = false;
      this.setState(state);
      this.setError('Problema encontrado ao salvar Preço/Plano da empresa');
    }.bind(this));
  }

  saveHolderAndDependents(loopIndex=0) {
    if (loopIndex < (this.state.holderList.length - 1)) {
      let h = {
        firstName: this.state.holderList[loopIndex].firstName.value,
        cpf: this.state.holderList[loopIndex].cpf.value,
        email: this.state.holderList[loopIndex].email.value,
        cellPhone: this.state.holderList[loopIndex].cellPhone.value,
        rg: this.state.holderList[loopIndex].rg.value,
        rgEmitter: this.state.holderList[loopIndex].rgEmitter.value,
        dateOfBirth: this.state.holderList[loopIndex].dateOfBirth.value,
        motherName: this.state.holderList[loopIndex].motherName.value,
        gender: this.state.holderList[loopIndex].gender.value,
        plansId: this.state.holderList[loopIndex].plansId.value,
        susNumber: this.state.holderList[loopIndex].susNumber.value,
        isHolder: true,
        companyId: this.state.companyId,
      };
  
      axios.post(configBase.api + 'Dependents?access_token='+localStorage.getItem('planos_t'), h)
      .then((result) => {
        //Caso o titular tenha dependentes
        if (this.state.holderList[loopIndex].dependents && this.state.holderList[loopIndex].dependents.length > 0) {
          let depList = [];
  
          for (let i = 0; i < this.state.holderList[loopIndex].dependents.length - 1; i++) {
            depList.push({
              firstName: this.state.holderList[loopIndex].dependents[i].firstName.value,
              cpf: this.state.holderList[loopIndex].dependents[i].cpf.value,
              email: this.state.holderList[loopIndex].dependents[i].email.value,
              cellPhone: this.state.holderList[loopIndex].dependents[i].cellPhone.value,
              rg: this.state.holderList[loopIndex].dependents[i].rg.value,
              rgEmitter: this.state.holderList[loopIndex].dependents[i].rgEmitter.value,
              dateOfBirth: this.state.holderList[loopIndex].dependents[i].dateOfBirth.value,
              motherName: this.state.holderList[loopIndex].dependents[i].motherName.value,
              gender: this.state.holderList[loopIndex].dependents[i].gender.value,
              parentage: this.state.holderList[loopIndex].dependents[i].parentage.value,
              plansId: this.state.holderList[loopIndex].dependents[i].plansId.value,
              susNumber: this.state.holderList[loopIndex].dependents[i].susNumber.value,
              isHolder: false,
              companyId: this.state.companyId,
              holderId: result.data.id,
            });
          }
  
          axios.post(configBase.api + 'Dependents?access_token='+localStorage.getItem('planos_t'), depList)
          .then(() => {
            loopIndex = loopIndex + 1;
            this.saveHolderAndDependents(loopIndex);
          })
          .catch(function () {
            this.setError('Problema encontrado ao salvar dependentes');
          }.bind(this));
        }
        else {
          loopIndex = loopIndex + 1;
          this.saveHolderAndDependents(loopIndex);
        }
      })
      .catch(function () {
        let state = this.state;
        state.stepper = state.stepper + 1;
        state.loadingButtonNext = false;
        this.setState(state);
        this.setError('Problema encontrado ao salvar titular');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.stepper = state.stepper + 1;
      state.loadingButtonNext = false;
      this.setState(state);
      this.showButtons(state.stepper);
    }
  }

  checkFieldStep3() {
    let data = this.state.imagesDocsUrl;
    let error = false;
    let state = this.state;

    Object.keys(data).forEach(function(key) {
      if (key !== 'usersTable') {
        if (data[key].required === true && document.getElementById('imagem_'+key).value === "") {
          state.imagesDocsUrl[key].error = 'Documento obrigatório';
          error = true;
        }
      }
    });

    if (error === false) {
      this.saveDocs();
      this.saveCompany('EM ANÁLISE');
    }
    else {
      let state = this.state;
      state.stepper = state.stepper + 1;
      state.loadingButtonNext = false;
      this.setState(state);
      this.setError('Campos com erro');
    }

    this.setState(state);
  }

  saveDocs() {
    let dataPost = {
      id: this.state.companyId,
      imagesDocId: '',
      imagesDocs: {
        usersTable: document.getElementById('imagem_usersTable').value,
        //usersTableExt: this.state.usersTableExt,
        rg: document.getElementById('imagem_rg').value,
        rg2: document.getElementById('imagem_rg2').value,
        cpf: document.getElementById('imagem_cpf').value,
        cnpj: document.getElementById('imagem_cnpj').value,
        address: document.getElementById('imagem_address').value,
        physicalContract1: document.getElementById('imagem_physicalContract1').value,
        physicalContract2: "",
        physicalContract3: "",
        others: document.getElementById('imagem_others').value,
      },
    };

    axios.post(configBase.api + 'Companies/saveDocsCompany?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then(() => {
      let state = this.state;
      state.stepper = state.stepper + 1;
      this.setState(state);
      this.showButtons(state.stepper);
    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar anexos');
    }.bind(this));
  }

  sendEmail() {
    /* let state = this.state;
    state.finishedLoadingMsg = 'ENVIANDO EMAIL...';
    state.finishedLoadingCompleted = 50;
    this.setState(state);

    let dataPost = {
      id: this.state.companyId
    };

    axios.post(configBase.api + 'Companies/SendEmailCompanyCreated?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then(() => { */
      this.saveCompany('EM ANÁLISE');
      let state = this.state;
      state.finishedLoadingMsg = 'PROPOSTA SALVA COM SUCESSO';
      state.finishedLoadingCompleted = 100;
      state.proposalSuccess = true;
      this.setState(state);
    /* })
    .catch(function () {
      this.setError('Problema encontrado ao enviar email');
    }.bind(this)); */
  }

  fnPlansSelectedId(event) {
    let state = this.state;
    state.plansSelectedId.value = event.target.value;
    state.plansSelectedId.error = '';
    this.setState(state);
  }

  setNameHead() {
    let state = this.state;
    state.nameHead = this.state.fieldStep1.fantasyName.value;
    this.setState(state);
  }

  finishedModalOpen() {
    let state = this.state;
    state.finishedModal = true;
    this.fullScreenModalFn();
    this.setState(state);
  }

  finishedModalClose() {
    let state = this.state;
    state.finishedModal = false;
    state.finishedModalMinWidth = 300;
    this.setState(state);
  }

  goDashboard() {
    this.finishedModalClose();
    this.props.history.push(`${process.env.PUBLIC_URL}/dashboard`);
  }

  beforeSubmitForm() {
    let state = this.state;
    state.finishedLoading = true;

    if (state.fullScreenModal === false)
      state.finishedModalMinWidth = 600;

    this.setState(state);

    this.sendEmail();
  }

  reteveAdesaoOn() {
    let state = this.state;
    state.fieldStep1.reteveAdesao.value = true;
    this.setWarning('Adesão retida pelo vendedor')
    this.setState(state);
  }

  reteveAdesaoOff() {
    let state = this.state;
    state.fieldStep1.reteveAdesao.value = false;
    this.setState(state);
  }

  setWarning(msg) {
    let state = this.state;
    state.warningRequest = true;
    state.msgWarningRequest = msg;
    this.setState(state);
  }

  warningClose() {
    let state = this.state;
    state.warningRequest = false;
    state.msgWarningRequest = '';
    this.setState(state);
  }

  addressTypeToResume() {
    if (this.state.fieldStep1.addressType.value) {
      for (let i = 0; i < this.state.addressTypeList.length; i++) {
        if (this.state.fieldStep1.addressType.value.toString() === this.state.addressTypeList[i].Id.toString()) {
          return this.state.addressTypeList[i].Nome;
        }
      }
    }
  }

  stateToResume() {
    if (this.state.fieldStep1.state.value) {
      for (let i = 0; i < this.state.stateList.length; i++) {
        if (this.state.fieldStep1.state.value.toString() === this.state.stateList[i].Id.toString()) {
          return this.state.stateList[i].Sigla;
        }
      }
    }
  }

  cityToResume()  {
    if (this.state.fieldStep1.city.value) {
      for (let i = 0; i < this.state.cityList.length; i++) {
        if (this.state.fieldStep1.city.value.toString() === this.state.cityList[i].Id.toString()) {
          return this.state.cityList[i].Nome;
        }
      }
    }
  }

  districtToResume() {
    if (this.state.fieldStep1.district.value) {
      for (let i = 0; i < this.state.districtList.length; i++) {
        if (this.state.fieldStep1.district.value.toString() === this.state.districtList[i].Id.toString()) {
          return this.state.districtList[i].Nome;
        }
      }
    }
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }



  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="formulario">
          {/* Para armazenar hash 64 dos arquivos */}
          <input id="imagem_cpf" type="hidden"/>
          <input id="imagem_rg" type="hidden"/>
          <input id="imagem_rg2" type="hidden"/>
          <input id="imagem_cnpj" type="hidden"/>
          <input id="imagem_address" type="hidden"/>
          <input id="imagem_physicalContract1" type="hidden"/>
          <input id="imagem_others" type="hidden"/>
          <input id="imagem_usersTable" type="hidden"/>

          <div id="formularioBarra">
            <Paper elevation={0} className="paper">
              <div id="formularioTitulo">
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  INCLUIR PROPOSTA PJ
                </Typography>
              </div>

              <div id="formularioDados">
                <div id="formularioDadosPlano">

                  {
                    this.state.value_total !== '0,00' && (
                  <div id="formularioDadosPlanoValor">
                    <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                      Total do plano
                    </Typography>
                    <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                      R$ {this.state.value_total}
                    </Typography>
                  </div>
                    )
                  }

                  {
                    this.state.nameHead.length > 0 && (
                  <div id="formularioDadosPlanoNome">
                    <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                      Empresa
                    </Typography>
                    <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                      {this.state.nameHead.toUpperCase()}
                    </Typography>
                  </div>
                    )
                  }

                  {
                    this.state.totalBeneficiaries > 0 && (
                  <div id="formularioDadosPlanoDependentes">
                    <Typography variant="body2" gutterBottom style={{margin: 0, lineHeight: '8px', fontSize: 10}}>
                      Beneficiários
                    </Typography>
                    <Typography variant="button" gutterBottom style={{fontSize: 11}}>
                      {this.state.totalBeneficiaries}
                    </Typography>
                  </div>
                    )
                  }

                </div>
              </div>

              <div id="formularioBotoes">
                {
                  /* this.state.showButtonBack === true ? (
                <div style={{marginRight: 10}}>
                  <Button
                    style={{fontSize: 11, backgroundColor: '#636d77', color: '#fff'}}
                    fullWidth={true}
                    variant="contained"
                    size="small"
                    onClick={this.backStep.bind(this)}
                    color="default"
                  >
                    VOLTAR
                  </Button>
                </div>
                  ) : ('') */
                }

                {
                  /* this.state.showButtonPrint === true ? (
                <ReactToPrint
                  trigger={() => 
                    <div style={{marginRight: 10}}>
                      <Button
                        style={{fontSize: 11, backgroundColor: '#636d77', color: '#fff'}}
                        fullWidth={true}
                        variant="contained"
                        size="small"
                        startIcon={<PrintIcon />}
                        //onClick={this.backStep.bind(this)}
                        color="default"
                        ref={this.printTrigger}
                      >
                        IMPRIMIR
                      </Button>
                    </div>
                  }
                  content={() => this.printContent}
                />
                  ) : ('') */
                }

                {
                  this.state.showButtonNext === true ? (
                <div className="containerButton">
                  <Button
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    fullWidth={true}
                    variant="contained"
                    size="small"
                    onClick={this.nextStep.bind(this)}
                    color="primary"
                    disabled={this.state.fieldStep1.loadingButtonNext}
                  >
                    AVANÇAR
                  </Button>

                  {
                    this.state.fieldStep1.loadingButtonNext === true ? (
                  <CircularProgress size={24} className="progressButton" />
                    ) : ('')
                  }
                </div>
                  ) : ('')
                }

                {
                  this.state.showButtonFinished === true ? (
                <div>
                  <Button
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    fullWidth={true}
                    variant="contained"
                    size="small"
                    onClick={this.finishedModalOpen.bind(this)}
                    color="primary"
                  >
                    CONCLUIR
                  </Button>
                </div>
                  ) : ('')
                }

              </div>
            </Paper>
          </div>

          <div id="formularioConteudo">
            <Stepper
              //nonLinear
              activeStep={this.state.stepper}
              orientation={this.state.orientationStepper}
              style={{background: 'transparent', paddingLeft: 20}}
            >
              <Step className="formularioStepLabel">
                <StepLabel completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>EMPRESA</div>
                </StepLabel>
              </Step>

              <Step className="formularioStepLabel">
                <StepLabel completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>BENEFICIÁRIOS</div>
                </StepLabel>
              </Step>

              <Step className="formularioStepLabel">
                <StepLabel completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>DOCUMENTO ANEXADOS</div>
                </StepLabel>
              </Step>

              <Step className="formularioStepLabel">
                <StepLabel completed={false}>
                  <div style={{maxWidth: 100, fontSize: 11, lineHeight: '13px'}}>RESUMO</div>
                </StepLabel>
              </Step>
            </Stepper>

            {
              this.state.stepper === 0 ? (
            <div className="formularioConteudoPaper">

              {
                localStorage.getItem('planos_y') === 'BROKER' && (
              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Vendedor
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.chooseSalesmanSelect.error.length > 0 ? (true):(false)}
                        helperText={this.state.chooseSalesmanSelect.error}
                        label="Vendedor *"
                        variant="outlined"
                        size="small"
                        name="addressTypeFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.chooseSalesmanSelect.value}
                        onChange={this.salesmanChange.bind(this)}
                      >
                        <option value="null">Selecione</option>
                      {this.state.listSalesman.map((item, index) =>
                        <option key={index} value={item.id}>{item.user.name}</option>
                      )}
                      </TextField>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
                )
              }

              <Paper elevation={0} className="paperForm" style={{backgroundColor: configBase.corPrincipal}}>
                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={9} md={9} lg={10}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"
                        style={{
                          color: configBase.corSecundaria,
                          top: 6,
                          position: 'relative',
                          fontSize: 12
                        }}
                      >
                        RETEVE ADESÃO?
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={2}>
                    {
                      this.state.fieldStep1.reteveAdesao.value === false ? (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corPrincipal,
                              color: configBase.corSecundaria,
                              border: '1px solid '+configBase.corSecundaria,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOn.bind(this)}
                            color="primary"
                          >
                            SIM
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corSecundaria,
                              color: configBase.corPrincipal,
                              border: '1px solid '+configBase.corPrincipal,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOff.bind(this)}
                            color="primary"
                          >
                            NÃO
                          </Button>
                        </Grid>
                      </Grid>
                      ) : (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corSecundaria,
                              color: configBase.corPrincipal,
                              border: '1px solid '+configBase.corPrincipal,
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOn.bind(this)}
                            color="primary"
                          >
                            SIM
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{
                              backgroundColor: configBase.corPrincipal,
                              color: configBase.corSecundaria,
                              border: '1px solid '+configBase.corSecundaria,                              
                              maxWidth: 70
                            }}
                            fullWidth={true}
                            variant="contained"
                            size="small"
                            onClick={this.reteveAdesaoOff.bind(this)}
                            color="primary"
                          >
                            NÃO
                          </Button>
                        </Grid>
                      </Grid>
                      )
                    }
                    </Grid>
                  </Grid>
                </div>
              </Paper>

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Dados da Empresa
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={5} lg={5}>
                      <InputMask
                        mask="99.999.999/9999-99"
                        maskChar=" "
                        disabled={this.state.fieldStep1.cnpj.loading}
                        value={this.state.fieldStep1.cnpj.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateCnpj.bind(this)}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cnpj.required === true ? ("CNPJ *"):("CNPJ")}
                          variant="outlined"
                          size="small"
                          name="cnpj"
                          error={this.state.fieldStep1.cnpj.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cnpj.error}
                          disabled={this.state.fieldStep1.cnpj.loading}
                        />}
                      </InputMask>
                    </Grid>

                    <Grid item xs={12} sm={12} md={7} lg={7}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.infoEmailInvoice.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.infoEmailInvoice.error}
                        label={this.state.fieldStep1.infoEmailInvoice.required === true ? ("Email *"):("Email")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="infoEmailInvoice"
                        value={this.state.fieldStep1.infoEmailInvoice.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <InputMask
                        mask="(99) 9999-9999"
                        maskChar=" "
                        value={this.state.fieldStep1.homePhone.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateTel.bind(this, 'homePhone')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.homePhone.required === true ? ("Tel. Fixo *"):("Tel. Fixo")}
                          error={this.state.fieldStep1.homePhone.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.homePhone.error}
                          variant="outlined"
                          size="small"
                          name="homePhone"
                        />}
                      </InputMask>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        value={this.state.fieldStep1.cellPhone.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateCell.bind(this, 'cellPhone')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cellPhone.required === true ? ("Celular *"):("Celular")}
                          error={this.state.fieldStep1.cellPhone.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cellPhone.error}
                          variant="outlined"
                          size="small"
                          name="cellPhone"
                        />}
                      </InputMask>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        value={this.state.fieldStep1.cellPhone2.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateCell.bind(this, 'cellPhone2')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.cellPhone2.required === true ? ("2º Celular *"):("2º Celular")}
                          error={this.state.fieldStep1.cellPhone2.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cellPhone2.error}
                          variant="outlined"
                          //type={this.state.fieldStep1.cellPhone2.type}
                          size="small"
                          name="cellPhone2"
                        />}
                      </InputMask>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.fantasyName.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.fantasyName.error}
                        label={this.state.fieldStep1.fantasyName.required === true ? ("Nome Fantasia *"):("Nome Fantasia")}
                        type={this.state.fieldStep1.fantasyName.type}
                        variant="outlined"
                        size="small"
                        name="fantasyName"
                        value={this.state.fieldStep1.fantasyName.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.setNameHead.bind(this)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.businessName.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.businessName.error}
                        label={this.state.fieldStep1.businessName.required === true ? ("Razão Social *"):("Razão Social")}
                        type={this.state.fieldStep1.businessName.type}
                        variant="outlined"
                        size="small"
                        name="businessName"
                        value={this.state.fieldStep1.businessName.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>

                  </Grid>
                </div>
              </Paper>

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Endereço
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <InputMask
                        mask="99.999-999"
                        maskChar=" "
                        value={this.state.fieldStep1.cep.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      >
                        {() => <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="cep"
                          error={this.state.fieldStep1.cep.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.cep.error}
                          label={this.state.fieldStep1.cep.required === true ? ("CEP *"):("CEP")}
                        />}
                      </InputMask>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.addressType.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressType.error}
                        label={this.state.fieldStep1.addressType.required === true ? ("Logradouro *"):("Logradouro")}
                        variant="outlined"
                        size="small"
                        name="addressType"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.addressType.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.addressType.loading}
                      >
                        <option value="null">Selecione</option>
                      {this.state.addressTypeList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.addressType.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.address.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.address.error}
                        label={this.state.fieldStep1.address.required === true ? ("Endereço *"):("Endereço")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="address"
                        value={this.state.fieldStep1.address.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.address.loading}
                      />

                      {
                        this.state.fieldStep1.address.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <TextField
                        id="i_addressNumber"
                        fullWidth
                        error={this.state.fieldStep1.addressNumber.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressNumber.error}
                        label={this.state.fieldStep1.addressNumber.required === true ? ("Nº *"):("Nº")}
                        type="tell"
                        variant="outlined"
                        size="small"
                        name="addressNumber"
                        value={this.state.fieldStep1.addressNumber.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={1} lg={1} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.state.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.state.error}
                        label={this.state.fieldStep1.state.required === true ? ("UF *"):("UF")}
                        variant="outlined"
                        size="small"
                        name="state"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.state.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.state.loading}
                      >
                        <option value="null">UF</option>
                      {this.state.stateList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Sigla}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.state.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.addressComplement.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.addressComplement.error}
                        label={this.state.fieldStep1.addressComplement.required === true ? ("Complemento *"):("Complemento")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="addressComplement"
                        value={this.state.fieldStep1.addressComplement.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.city.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.city.error}
                        label={this.state.fieldStep1.city.required === true ? ("Município *"):("Município")}
                        variant="outlined"
                        size="small"
                        name="city"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.city.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.city.loading}
                      >
                        <option value="null">Selecione</option>
                      {this.state.cityList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.city.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.fieldStep1.district.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.district.error}
                        label={this.state.fieldStep1.district.required === true ? ("Bairro *"):("Bairro")}
                        variant="outlined"
                        size="small"
                        name="district"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.fieldStep1.district.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        disabled={this.state.fieldStep1.district.loading}
                      >
                        <option value="null">Selecione</option>
                      {this.state.districtList.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.fieldStep1.district.loading === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>

                  </Grid>
                </div>
              </Paper>

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Representante Legal da Empresa
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                      <TextField
                        fullWidth
                        error={this.state.fieldStep1.legalResponsible.error.length > 0 ? (true):(false)}
                        helperText={this.state.fieldStep1.legalResponsible.error}
                        label={this.state.fieldStep1.legalResponsible.required === true ? ("Nome Completo *"):("Nome Completo")}
                        type="text"
                        variant="outlined"
                        size="small"
                        name="legalResponsible"
                        value={this.state.fieldStep1.legalResponsible.value}
                        onChange={this.updateFieldStep1.bind(this)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <InputMask
                        mask="999.999.999-99"
                        maskChar=" "
                        disabled={this.state.fieldStep1.legalResponsibleCpf.loading}
                        value={this.state.fieldStep1.legalResponsibleCpf.value}
                        onChange={this.updateFieldStep1.bind(this)}
                        onBlur={this.validateAllCpf.bind(this, 'fieldStep1', 'legalResponsibleCpf')}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.fieldStep1.legalResponsibleCpf.required === true ? ("CPF *"):("CPF")}
                          variant="outlined"
                          size="small"
                          name="legalResponsibleCpf"
                          error={this.state.fieldStep1.legalResponsibleCpf.error.length > 0 ? (true):(false)}
                          helperText={this.state.fieldStep1.legalResponsibleCpf.error}
                        />}
                      </InputMask>
                    </Grid>

                  </Grid>
                </div>
              </Paper>

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Tipos de Planos Disponíveis
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={10} lg={10}>
                      <div className="containerButton" style={{ marginTop: 20 }}>
                        <TextField
                          fullWidth
                          select
                          label="Local de Utilização"
                          variant="outlined"
                          size="small"
                          name="localSelect"
                          SelectProps={{
                            native: true,
                          }}
                          value={this.state.localSelect}
                          disabled={this.state.disabledLocalSelect}
                          onChange={this.localChange.bind(this)}
                        >
                          <option value="null">Selecionar</option>
                          {this.state.localList.map((item, index) =>
                          <option key={index} value={item.value}>{item.label}</option>
                          )}
                        </TextField>
                        {
                          this.state.disabledLocalSelect === true ? (
                            <CircularProgress size={24} className="progressButton" />
                          ) : ('')
                        }
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={10} lg={10}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.plansSelectedId.error.length > 0 ? (true):(false)}
                        helperText={this.state.plansSelectedId.error}
                        label={this.state.plansSelectedId.required === true ? ("Plano *"):("Plano")}
                        variant="outlined"
                        size="small"
                        name="plansSelectedId"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.plansSelectedId.value}
                        onChange={this.fnPlansSelectedId.bind(this)}
                        disabled={false}
                      >
                        <option value="null">Selecionar</option>
                        {this.state.plansList.map((item, index) =>
                        <option key={index} value={item.value}>{item.label}</option>
                        )}
                      </TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                    {
                      this.state.plansSelectedId.value !== 'null' ? (
                      <div style={{marginTop: 4}}>
                        <Button
                          style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                          fullWidth={false}
                          variant="contained"
                          size="small"
                          onClick={this.addPlansListChosen.bind(this)}
                          color="default"
                        >
                          ADD PLANO
                        </Button>
                      </div>                        
                      ) : (
                      <div style={{marginTop: 4}}>
                        <Button
                          style={{fontSize: 11}}
                          fullWidth={false}
                          variant="contained"
                          size="small"
                          color="default"
                          disabled={true}
                        >
                          ADD PLANO
                        </Button>
                      </div>
                      )
                    }

                    </Grid>

                  </Grid>

                  {/* ############# CSS PARA DATATABLE ############# */}
                  <link
                    rel="stylesheet" type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
                  />
                  <link
                    rel="stylesheet" type="text/css"
                    href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
                  />
                  {/* ############# CSS PARA DATATABLE ############# */}

                  {
                    this.state.fieldStep1.plansListChosen.value.length > 0 && (
                  <div>
                    {
                      this.state.planoTipoFaixa === false ? (
                    <table
                      id="table_id"
                      className="mdl-data-table table-striped display nowrap"
                      style={{width:'100%', marginTop: 25, marginBottom: 25}}
                    >
                      <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                        <tr style={this.styles.theadTr}>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                            >
                              PLANO
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh}>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                              >
                              VAL. TITULAR
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                              >
                              VAL. DEPENDENTE
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                              >
                              VAL. AGREGADO
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                            >
                              AÇÕES
                            </Typography>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                      {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                        <tr
                          key={index}
                          className="row_table"
                          style={this.styles.theadTh}
                        >
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {item.codeS4 + ' - '+ item.name}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {'R$ '+item.valores[0].valorTitular}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {'R$ '+item.valores[0].valorDependente}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {'R$ '+item.valores[0].valorAgregado}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <div style={{textAlign: 'left', paddingLeft: 10}}>
                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.modalConfirmRemovePlanOpen.bind(this, index)}
                              >
                                <DeleteIcon />
                              </IconButton>

                              {/* <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                //onClick={this.editHolder.bind(this, index)}
                              >
                                <EditIcon />
                              </IconButton> */}
                            </div>
                          </td>
                        </tr>
                      )}
                      </tbody>
                    </table>
                    ) : (
                    <table
                      id="table_id"
                      className="mdl-data-table table-striped display nowrap"
                      style={{width:'100%', marginTop: 25, marginBottom: 25}}
                    >
                      <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                        <tr style={this.styles.theadTr}>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                            >
                              PLANO
                            </Typography>
                          </th>
                        {this.state.fieldStep1.plansListChosen.value[0].valores.map((item, index) =>
                          (index + 1) < this.state.fieldStep1.plansListChosen.value[0].valores.length ? (

                          <th key={index} style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                            >
                              DE {item.qtdInicial} ATÉ {item.qtdFinal}
                            </Typography>
                          </th>
                          ) : (
                          <th key={index} style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                            >
                              A partir de {item.qtdInicial}
                            </Typography>
                          </th>
                          )

                        )}

                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                            >
                              AÇÕES
                            </Typography>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                        <tr
                          key={index}
                          className="row_table"
                          style={this.styles.theadTh}
                        >
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {item.codeS4 + ' - '+ item.name}
                            </Typography>
                          </td>

                          {this.state.fieldStep1.plansListChosen.value[index].valores.map((item2, index2) =>
                          <td key={index2} style={{padding: 0, height: 40}}>
                            <Typography key={index2} variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {'R$ '+item2.valorTitular}
                            </Typography>
                          </td>
                          )}

                          <td style={{padding: 0, height: 40}}>
                            <div style={{textAlign: 'left', paddingLeft: 10}}>
                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.modalConfirmRemovePlanOpen.bind(this, index)}
                              >
                                <DeleteIcon />
                              </IconButton>

                              {/* <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                //onClick={this.editHolder.bind(this, index)}
                              >
                                <EditIcon />
                              </IconButton> */}
                            </div>
                          </td>
                        </tr>
                        )}
                      </tbody>
                    </table>
                    )
                  }

                    <Dialog
                      fullScreen={this.state.fullScreenModal}
                      open={this.state.modalConfirmRemovePlan}
                      onClose={this.modalConfirmRemovePlanClose.bind(this)}
                      aria-labelledby="i_modalConfirm"
                    >
                      <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Deseja realmente remover o plano
                          <strong>{' ' +
                            this.state.fieldStep1.plansListChosen.value[this.state.planRemoveIndex].codeS4 + ' - ' +
                            this.state.fieldStep1.plansListChosen.value[this.state.planRemoveIndex].name}
                          </strong>?
                        </DialogContentText>
                      </DialogContent>

                      <DialogActions>
                        <Button autoFocus color="primary"
                          onClick={this.modalConfirmRemovePlanClose.bind(this)}
                        >
                          NÃO
                        </Button>
                        <Button
                          color="primary"
                          onClick={this.removePlan.bind(this)}
                        >
                          SIM
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                    )
                  }

                </div>
              </Paper>

            </div>
              ) : (
                this.state.stepper === 1 ? (
            <div className="formularioConteudoPaper">
              {
                localStorage.getItem('planos_y') === 'BROKER' && (
              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Vendedor
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.chooseSalesmanSelect.error.length > 0 ? (true):(false)}
                        helperText={this.state.chooseSalesmanSelect.error}
                        label="Vendedor *"
                        variant="outlined"
                        size="small"
                        name="addressTypeFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.chooseSalesmanSelect.value}
                        disabled
                      >
                        <option value="null">Selecione</option>
                      {this.state.listSalesman.map((item, index) =>
                        <option key={index} value={item.id}>{item.user.name}</option>
                      )}
                      </TextField>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
                )
              }

              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Formas de Inclusão
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={1} md={1} lg={2}></Grid>

                    {/* <Grid item xs={12} sm={5} md={5} lg={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            style={{color: configBase.corPrincipal}}
                            checked={this.state.checkFile}
                            onChange={this.checkChange.bind(this)}
                            name="checkFile"
                            color="primary"
                          />
                        }
                        label="USAR PLANILHA"
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={5} md={12} lg={12} style={{textAlign: 'center'}}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            style={{color: configBase.corPrincipal}}
                            checked={this.state.checkForm}
                            onChange={this.checkChange.bind(this)}
                            name="checkForm"
                            color="primary"
                          />
                        }
                        label="USAR FORMULÁRIO"
                      />
                    </Grid>

                    <Grid item xs={12} sm={1} md={1} lg={2}></Grid>
                  </Grid>
                </div>
              </Paper>

              {
                this.state.checkFile === true && (
              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Adicionar Beneficiários
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <div>
                    <Typography variant="button" display="block" gutterBottom>
                      PASSO 1:{' '}
                      <Typography variant="overline" display="inline" gutterBottom>
                        BAIXAR PLANILHA MODELO E INSERIR BENEFICIÁRIOS
                      </Typography>
                    </Typography>

                    <a
                      href={`${process.env.PUBLIC_URL}/files/PLANILHA_INCLUSAO_FUNCIONARIOS.xlsx`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{color: configBase.corPrincipal}}
                    >
                      <CloudDownloadIcon className="iconLarge" fontSize="large"/>
                    </a>
                  </div>

                  <div>
                    <Divider style={{margin: '20px 0 10px 0'}} />
                  </div>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3} md={4} lg={6}></Grid>
                    <Grid item xs={12} sm={9} md={8} lg={6}>
                      <Typography variant="button" display="block" gutterBottom>
                        PASSO 2:{' '}
                        <Typography variant="overline" display="inline" gutterBottom>
                          ANEXAR PLANILHA PREENCHIDA COM BENEFICIÁRIOS
                        </Typography>
                      </Typography>

                      <div>
                        {/* ################### Planilha ################### */}
                        <Card>
                          <CardHeader
                            className="title_docs"
                            title="ANEXAR PLANILHA"
                          />

                          <Divider style={{marginBottom: 10}}/>

                          <CardActionArea
                            onClick={this.dropzoneDialogOpen.bind(this, 'usersTable')}
                          >
                            {
                              this.state.imagesDocsUrl.usersTable.url.length > 0 ? (
                            <div style={{textAlign: 'center', paddingTop: 8, minHeight: 60}}>
                              <ListAltIcon fontSize="large" style={{fontSize: 60}}/>
                            </div>
                              ) : (
                                this.state.imagesDocsUrl.usersTable.error.length > 0 ? (
                            <div style={{textAlign: 'center', paddingTop: 8, minHeight: 60}}>
                              <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                                {this.state.imagesDocsUrl.usersTable.error}
                              </Alert>
                            </div>
                                ) : (
                            <div style={{textAlign: 'center', paddingTop: 8, minHeight: 60}}>
                              <MuiAlert severity="info" variant="filled" elevation={0}
                                style={{width: '90%', margin: '0 auto'}}
                              >
                                Nenhum arquivo anexado
                              </MuiAlert>
                            </div>
                                )
                              )
                            }

                            <Divider style={{marginTop: 10, marginBottom: 10}}/>
                          </CardActionArea>

                          {
                            this.state.imagesDocsUrl.usersTable.url.length > 0 ? (
                          <CardActions>
                            <Button
                              size="small" color="primary"
                              onClick={this.dropzoneDialogOpen.bind(this, 'usersTable')}
                            >
                              Editar
                            </Button>
                          </CardActions>
                              ) : (
                          <CardActions>
                            <Button
                              size="small" color="primary"
                              onClick={this.dropzoneDialogOpen.bind(this, 'usersTable')}
                            >
                              SELECIONAR
                            </Button>
                          </CardActions>
                              )
                            }

                        </Card>
                      </div>
                    </Grid>
                  </Grid>

                  <div>
                    <Divider style={{margin: '30px 0'}} />
                  </div>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={9} md={8} lg={6}>
                      <Typography variant="button" display="block" gutterBottom>
                        PASSO 3:{' '}
                        <Typography variant="overline" display="inline" gutterBottom>
                          VALIDAÇÃO DOS BENEFICIÁRIOS
                        </Typography>
                      </Typography>

                      <div id="i_msgUsersTable">
                        <MuiAlert
                          severity={this.state.typeMsgUsersTable}
                          variant="filled"
                          elevation={0}
                          //style={{width: '90%', margin: '0 auto'}}
                        >
                          {this.state.msgUsersTable}
                        </MuiAlert>
                      </div>
                    </Grid>
                  </Grid>

                </div>

              </Paper>
                )
              }

              {
                this.state.checkForm === true && (
              <div>
                {
                  this.state.holderList.length > 1 ? (
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <Typography
                      variant="h6"
                      gutterBottom
                      className="titlePaperForm"
                      style={{display: 'inline-block'}}
                    >
                      Adicionar Beneficiários
                    </Typography>
                    <Button
                      style={{
                        fontSize: 11,
                        backgroundColor: configBase.corPrincipal,
                        color: configBase.corSecundaria,
                        float: 'right',
                        bottom: 3
                      }}
                      variant="contained"
                      size="small"
                      onClick={this.modalAddHolderFn.bind(this)}
                      color="primary"
                    >
                      <AddIcon style={{fontSize: 19}} />
                      TITULAR
                    </Button>
                  </div>

                  <div>
                    <Divider />
                  </div>

                  <div className="paper">
                    {/* ############# CSS PARA DATATABLE ############# */}
                    <link
                      rel="stylesheet" type="text/css"
                      href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
                    />
                    <link
                      rel="stylesheet" type="text/css"
                      href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
                    />
                    {/* ############# CSS PARA DATATABLE ############# */}

                    <table id="table_id" className="mdl-data-table display nowrap" style={{width:'100%'}}>
                      <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                        <tr style={this.styles.theadTr}>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                            >
                              TIPO
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh}>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                              >
                              NOME
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                              >
                              CPF
                            </Typography>
                          </th>
                          <th style={this.styles.theadTh} className='no-sort'>
                            <Typography variant="button" display="block" gutterBottom
                              style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                            >
                              AÇÕES
                            </Typography>
                          </th>
                        </tr>
                      </thead>

                      {this.state.holderList.map((item, index) =>
                        index < (this.state.holderList.length - 1) && (
                      <tbody key={index}>
                        <tr
                          className="row_table"
                          style={this.styles.theadTh2}
                        >
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                            >
                              <span
                                style={{
                                  padding: '5px 7px', border: '1px solid '+configBase.corPrincipal,
                                  borderRadius: 5, color: configBase.corPrincipal
                                }}
                              >
                                TITULAR
                              </span>
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {item.firstName.value}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                            >
                              {item.cpf.value}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <div style={{textAlign: 'left', paddingLeft: 10}}>
                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.modalConfirmRemoveHolderOpen.bind(this, index)}
                              >
                                <DeleteIcon />
                              </IconButton>

                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.editHolder.bind(this, index)}
                              >
                                <EditIcon />
                              </IconButton>

                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.verificaIsDependentEdit.bind(this, index, null)}
                              >
                                <GroupAddIcon />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                        {item.dependents.map((item2, index2) =>
                          index2 < (item.dependents.length - 1) && (
                        <tr
                          key={index2}
                          className="row_table"
                          style={this.styles.theadTh}
                        >
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                            >
                              <span
                                style={{
                                  padding: '5px 7px', border: '1px solid #757575',
                                  borderRadius: 5, color: '#757575'}}
                              >
                                DEP
                              </span>
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}>
                            <Typography variant="overline" display="block" gutterBottom
                              style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 40}}
                            >
                              {item2.firstName.value}
                            </Typography>
                          </td>
                          <td style={{padding: 0, height: 40}}></td>
                          <td style={{padding: 0, height: 40}}>
                            <div style={{textAlign: 'left', paddingLeft: 10}}>
                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.modalConfirmRemoveDependentOpen.bind(this, index2, index)}
                              >
                                <DeleteIcon />
                              </IconButton>

                              <IconButton
                                aria-label="delete"
                                style={{padding: '8px 8px'}}
                                onClick={this.editDependent.bind(this, index2, index)}
                              >
                                <EditIcon />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                          )
                        )}
                      </tbody>
                        )
                      )}
                    </table>
                  </div>

                </Paper>
                  ) : (
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <Typography
                      variant="h6"
                      gutterBottom
                      className="titlePaperForm"
                      style={{display: 'inline-block'}}
                    >
                      Adicionar Beneficiários
                    </Typography>
                    <Button
                      style={{
                        fontSize: 11,
                        backgroundColor: configBase.corPrincipal,
                        color: configBase.corSecundaria,
                        float: 'right',
                        bottom: 3
                      }}
                      variant="contained"
                      size="small"
                      onClick={this.modalAddHolderFn.bind(this)}
                      color="primary"
                    >
                      <AddIcon style={{fontSize: 19}} />
                      TITULAR
                    </Button>
                  </div>

                  <div>
                    <Divider />
                  </div>

                  <div className="paper">
                    <Typography variant="overline" display="block" gutterBottom>
                      SEM BENEFICIÁRIOS
                    </Typography>
                    <Typography variant="caption" display="block" gutterBottom>
                      Clique no botão para começar a adicionar
                    </Typography>
                  </div>

                </Paper>
                  )
                }

                <div>
                  <Dialog
                    fullScreen={this.state.fullScreenModal}
                    open={this.state.modalAddHolder}
                    onClose={this.modalAddHolderFn.bind(this)}
                    aria-labelledby="i_addHolder"
                  >
                    {
                      this.state.isHolderEdit === true ? (
                    <DialogTitle id="i_addHolder">{"Editar Titular"}</DialogTitle>
                      ) : (
                    <DialogTitle id="i_addHolder">{"Novo Titular"}</DialogTitle>
                      )
                    }

                    <DialogContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].firstName.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].firstName.error}
                            label={this.state.holderList[this.state.holderIndex].firstName.required === true ? ("Nome Completo *"):("Nome Completo")}
                            type="text"
                            variant="outlined"
                            size="small"
                            name="firstName"
                            value={this.state.holderList[this.state.holderIndex].firstName.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <InputMask
                            mask="999.999.999-99"
                            maskChar=" "
                            value={this.state.holderList[this.state.holderIndex].cpf.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                            onBlur={this.verifyCPFModalForm.bind(this, 'holder')}
                          >
                            {() => <TextField
                              fullWidth
                              label={this.state.holderList[this.state.holderIndex].cpf.required === true ? ("CPF *"):("CPF")}
                              variant="outlined"
                              size="small"
                              name="cpf"
                              error={this.state.holderList[this.state.holderIndex].cpf.error.length > 0 ? (true):(false)}
                              helperText={this.state.holderList[this.state.holderIndex].cpf.error}
                            />}
                          </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].email.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].email.error}
                            label={this.state.holderList[this.state.holderIndex].email.required === true ? ("E-mail *"):("E-mail")}
                            type="email"
                            variant="outlined"
                            size="small"
                            name="email"
                            value={this.state.holderList[this.state.holderIndex].email.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                            onBlur={this.verifyEmailModalForm.bind(this, 'holder')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <InputMask
                            mask="(99) \9 9999-9999"
                            maskChar=" "
                            value={this.state.holderList[this.state.holderIndex].cellPhone.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          >
                            {() => <TextField
                              fullWidth
                              label={this.state.holderList[this.state.holderIndex].cellPhone.required === true ? ("Celular *"):("Celular")}
                              error={this.state.holderList[this.state.holderIndex].cellPhone.error.length > 0 ? (true):(false)}
                              helperText={this.state.holderList[this.state.holderIndex].cellPhone.error}
                              variant="outlined"
                              size="small"
                              name="cellPhone"
                            />}
                          </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].rg.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].rg.error}
                            label={this.state.holderList[this.state.holderIndex].rg.required === true ? ("RG *"):("RG")}
                            type="tel"
                            variant="outlined"
                            size="small"
                            name="rg"
                            value={this.state.holderList[this.state.holderIndex].rg.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].rgEmitter.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].rgEmitter.error}
                            label={this.state.holderList[this.state.holderIndex].rgEmitter.required === true ? ("Org. Emissor *"):("Org. Emissor")}
                            type={this.state.holderList[this.state.holderIndex].rgEmitter.type}
                            variant="outlined"
                            size="small"
                            name="rgEmitter"
                            value={this.state.holderList[this.state.holderIndex].rgEmitter.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                            inputProps={{maxLength:10}}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                            <KeyboardDatePicker
                              autoOk
                              fullWidth
                              error={this.state.holderList[this.state.holderIndex].dateOfBirth.error.length > 0 ? (true):(false)}
                              helperText={this.state.holderList[this.state.holderIndex].dateOfBirth.error}
                              variant="inline"
                              inputVariant="outlined"
                              label={this.state.holderList[this.state.holderIndex].dateOfBirth.required === true ? ("Data de Nascimento *"):("Data de Nascimento")}
                              format="dd/MM/yyyy"
                              size="small"
                              name="dateOfBirth"
                              value={
                                this.state.holderList[this.state.holderIndex].dateOfBirth.value === null ? (null) : (
                                  this.state.holderList[this.state.holderIndex].dateOfBirth.value+'T00:00:00'
                                )
                              }
                              onChange={this.updateFieldDate.bind(this, 'holder', 'dateOfBirth')}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            select
                            error={this.state.holderList[this.state.holderIndex].gender.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].gender.error}
                            label={this.state.holderList[this.state.holderIndex].gender.required === true ? ("Sexo *"):("Sexo")}
                            variant="outlined"
                            size="small"
                            name="gender"
                            SelectProps={{
                              native: true,
                            }}
                            value={this.state.holderList[this.state.holderIndex].gender.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          >
                            <option value="null">Selecione</option>
                            <option value="0">Feminino</option>
                            <option value="1">Masculino</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].susNumber.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].susNumber.error}
                            label={this.state.holderList[this.state.holderIndex].susNumber.required === true ? ("Cartão do SUS *"):("Cartão do SUS")}
                            type="text"
                            variant="outlined"
                            size="small"
                            name="susNumber"
                            value={this.state.holderList[this.state.holderIndex].susNumber.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].motherName.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].motherName.error}
                            label={this.state.holderList[this.state.holderIndex].motherName.required === true ? ("Mãe *"):("Mãe")}
                            type="text"
                            variant="outlined"
                            size="small"
                            name="motherName"
                            value={this.state.holderList[this.state.holderIndex].motherName.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            select
                            error={this.state.holderList[this.state.holderIndex].plansId.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].plansId.error}
                            label={this.state.holderList[this.state.holderIndex].plansId.required === true ? ("Plano *"):("Plano")}
                            variant="outlined"
                            size="small"
                            name="plansId"
                            SelectProps={{
                              native: true,
                            }}
                            value={this.state.holderList[this.state.holderIndex].plansId.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'holder')}
                          >
                            <option value="null">Selecione</option>
                          {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                            <option key={index} value={item.id}>
                              {item.codeS4 + '- ' + item.name}
                            </option>
                          )}
                          </TextField>
                        </Grid>

                      </Grid>
                    </DialogContent>

                    <DialogActions>
                      <Button autoFocus color="primary"
                        onClick={this.modalAddHolderFn.bind(this)}
                      >
                        FECHAR
                      </Button>
                      <Button
                        color="primary"
                        onClick={this.verifyAddHolder.bind(this)}
                      >
                        {
                          this.state.isHolderEdit === true ? ('EDITAR') : ('INSERIR')
                        }
                      </Button>
                    </DialogActions>
                  </Dialog>


                  <Dialog
                    fullScreen={this.state.fullScreenModal}
                    open={this.state.modalAddDependent}
                    onClose={this.modalAddDependentClose.bind(this)}
                    aria-labelledby="i_addDependent"
                  >
                    <DialogTitle id="i_addDependent">{"Novo Dependente"}</DialogTitle>
                    <DialogContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].firstName.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].firstName.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].firstName.required === true ? ("Nome Completo *"):("Nome Completo")}
                            type="text"
                            variant="outlined"
                            size="small"
                            name="firstName"
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].firstName.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <InputMask
                            mask="999.999.999-99"
                            maskChar=" "
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cpf.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                            onBlur={this.verifyCPFModalForm.bind(this, 'dependent')}
                          >
                            {() => <TextField
                              fullWidth
                              label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cpf.required === true ? ("CPF *"):("CPF")}
                              variant="outlined"
                              size="small"
                              name="cpf"
                              error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cpf.error.length > 0 ? (true):(false)}
                              helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cpf.error}
                            />}
                          </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].email.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].email.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].email.required === true ? ("E-mail *"):("E-mail")}
                            type="email"
                            variant="outlined"
                            size="small"
                            name="email"
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].email.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                            onBlur={this.verifyEmailModalForm.bind(this, 'dependent')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <InputMask
                            mask="(99) \9 9999-9999"
                            maskChar=" "
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cellPhone.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          >
                            {() => <TextField
                              fullWidth
                              label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cellPhone.required === true ? ("Celular *"):("Celular")}
                              error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cellPhone.error.length > 0 ? (true):(false)}
                              helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].cellPhone.error}
                              variant="outlined"
                              size="small"
                              name="cellPhone"
                            />}
                          </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rg.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rg.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rg.required === true ? ("RG *"):("RG")}
                            type="tel"
                            variant="outlined"
                            size="small"
                            name="rg"
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rg.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rgEmitter.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rgEmitter.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rgEmitter.required === true ? ("Org. Emissor *"):("Org. Emissor")}
                            type={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rgEmitter.type}
                            variant="outlined"
                            size="small"
                            name="rgEmitter"
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].rgEmitter.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                            inputProps={{maxLength:10}}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                            <KeyboardDatePicker
                              autoOk
                              fullWidth
                              error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].dateOfBirth.error.length > 0 ? (true):(false)}
                              helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].dateOfBirth.error}
                              variant="inline"
                              inputVariant="outlined"
                              label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].dateOfBirth.required === true ? ("Data de Nascimento *"):("Data de Nascimento")}
                              format="dd/MM/yyyy"
                              size="small"
                              name="dateOfBirth"
                              value={
                                this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].dateOfBirth.value === null ? (null) : (
                                  this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].dateOfBirth.value+'T00:00:00'
                                )
                              }
                              onChange={this.updateFieldDate.bind(this, 'dependent', 'dateOfBirth')}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            select
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].gender.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].gender.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].gender.required === true ? ("Sexo *"):("Sexo")}
                            variant="outlined"
                            size="small"
                            name="gender"
                            SelectProps={{
                              native: true,
                            }}
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].gender.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          >
                            <option value="null">Selecione</option>
                            <option value="0">Feminino</option>
                            <option value="1">Masculino</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            select
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].parentage.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].parentage.error}
                            label="Parentesco"
                            variant="outlined"
                            size="small"
                            name="parentage"
                            SelectProps={{
                              native: true,
                            }}
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].parentage.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          >
                            <option value="null">Selecione</option>
                            <option value="CÔNJUGE">Cônjuge</option>
                            <option value="FILHO">Filho</option>
                            <option value="PAI/MÃE">Pai/Mãe</option>
                            <option value="ENTEADO">Enteado</option>
                            <option value="OUTRO">Outro</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].susNumber.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].susNumber.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].susNumber.required === true ? ("Cartão do SUS *"):("Cartão do SUS")}
                            type="text"
                            variant="outlined"
                            size="small"
                            name="susNumber"
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].susNumber.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].motherName.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].motherName.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].motherName.required === true ? ("Mãe *"):("Mãe")}
                            type="text"
                            variant="outlined"
                            size="small"
                            name="motherName"
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].motherName.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            select
                            error={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].plansId.error.length > 0 ? (true):(false)}
                            helperText={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].plansId.error}
                            label={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].plansId.required === true ? ("Plano *"):("Plano")}
                            variant="outlined"
                            size="small"
                            name="plansId"
                            SelectProps={{
                              native: true,
                            }}
                            value={this.state.holderList[this.state.holderIndex].dependents[this.state.dependentIndex].plansId.value}
                            onChange={this.updateFieldsModalForm.bind(this, 'dependent')}
                          >
                            <option value="null">Selecione</option>
                          {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                            <option key={index} value={item.id}>
                              {item.codeS4 + '- ' + item.name}
                            </option>
                          )}
                          </TextField>
                        </Grid>

                      </Grid>
                    </DialogContent>

                    <DialogActions>
                      <Button autoFocus color="primary"
                        onClick={this.modalAddDependentClose.bind(this)}
                      >
                        FECHAR
                      </Button>
                      <Button
                        color="primary"
                        onClick={this.verifyAddDependent.bind(this)}
                      >
                        {
                          this.state.isDependentEdit === true ? ('EDITAR') : ('INSERIR')
                        }
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    fullScreen={this.state.fullScreenModal}
                    open={this.state.modalConfirmRemoveHolder}
                    onClose={this.modalConfirmRemoveHolderClose.bind(this)}
                    aria-labelledby="i_modalConfirm"
                  >
                    <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
                    <DialogContent>
                      {
                        this.state.holderList[this.state.holderDeleteIndex].dependents.length > 1 ? (
                      <DialogContentText>
                        Deseja realmente remover o titular
                        <strong>{' '+this.state.holderList[this.state.holderDeleteIndex].firstName.value}</strong> e seus dependentes?
                      </DialogContentText>
                        ) : (
                      <DialogContentText>
                        Deseja realmente remover o titular
                        <strong>{' '+this.state.holderList[this.state.holderDeleteIndex].firstName.value}</strong>?
                      </DialogContentText>
                        )
                      }
                    </DialogContent>

                    <DialogActions>
                      <Button autoFocus color="primary"
                        onClick={this.modalConfirmRemoveHolderClose.bind(this)}
                      >
                        NÃO
                      </Button>
                      <Button
                        color="primary"
                        onClick={this.removeHolder.bind(this)}
                      >
                        SIM
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    fullScreen={this.state.fullScreenModal}
                    open={this.state.modalConfirmRemoveDependent}
                    onClose={this.modalConfirmRemoveDependentClose.bind(this)}
                    aria-labelledby="i_modalConfirm"
                  >
                    <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Deseja realmente remover o dependente
                        <strong>{' '+this.state.holderList[this.state.holderIndex].dependents[this.state.dependentDeleteIndex].firstName.value}</strong>?
                      </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                      <Button autoFocus color="primary"
                        onClick={this.modalConfirmRemoveDependentClose.bind(this)}
                      >
                        NÃO
                      </Button>
                      <Button
                        color="primary"
                        onClick={this.removeDependent.bind(this)}
                      >
                        SIM
                      </Button>
                    </DialogActions>
                  </Dialog>

                </div>
              </div>
                )
              }

            </div>
                ) : (
                  this.state.stepper === 2 ? (
            <div className="formularioConteudoPaper">
              {
                localStorage.getItem('planos_y') === 'BROKER' && (
              <Paper elevation={0} className="paperForm">
                <div className="paper">
                  <Typography variant="h6" gutterBottom className="titlePaperForm">
                    Vendedor
                  </Typography>
                </div>

                <div>
                  <Divider />
                </div>

                <div className="paper">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        select
                        error={this.state.chooseSalesmanSelect.error.length > 0 ? (true):(false)}
                        helperText={this.state.chooseSalesmanSelect.error}
                        label="Vendedor *"
                        variant="outlined"
                        size="small"
                        name="addressTypeFm"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.chooseSalesmanSelect.value}
                        disabled
                      >
                        <option value="null">Selecione</option>
                      {this.state.listSalesman.map((item, index) =>
                        <option key={index} value={item.id}>{item.user.name}</option>
                      )}
                      </TextField>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
                )
              }

              <Paper elevation={0} className="paperForm" style={{backgroundColor: configBase.corPrincipal}}>
                <div className="paper">
                  <InfoOutlinedIcon style ={{color: configBase.corSecundaria, top: 2, position: 'relative'}}/>
                  <Typography
                    variant="overline" gutterBottom
                    style={{
                      color: configBase.corSecundaria,
                      textTransform: 'none',
                      fontSize: 13,
                      position: 'relative',
                      bottom: 5,
                      marginLeft: 10,
                    }}
                  >
                    Anexar cópias dos documentos do represetante legal e da empresa
                  </Typography>
                </div>
              </Paper>

              <div className="paper">
                <Grid container spacing={2}>
                  {/* ################### Imagem RG Frente ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="RG REPRES. LEGAL (FRENTE)"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                      >
                        {
                          this.state.imagesDocsUrl.rg.url.length > 0 ? (
                            this.state.imagesDocsUrl.rg.url.substr(this.state.imagesDocsUrl.rg.url.length - 3, this.state.imagesDocsUrl.rg.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="RG REPRES. LEGAL (FRENTE)"
                          height="140"
                          image={this.state.imagesDocsUrl.rg.url}
                          title="RG REPRES. LEGAL (FRENTE)"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.rg.error.length > 0 ? (
                        <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                          <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                            {this.state.imagesDocsUrl.rg.error}
                          </Alert>
                        </div>
                            ) : (
                        <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                          <MuiAlert severity="info" variant="filled" elevation={0}
                            style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                          >
                            Nenhum arquivo anexado
                          </MuiAlert>
                        </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.rg.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem RG Verso ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="RG REPRES. LEGAL (VERSO)"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                      >
                        {
                          this.state.imagesDocsUrl.rg2.url.length > 0 ? (
                            this.state.imagesDocsUrl.rg2.url.substr(this.state.imagesDocsUrl.rg2.url.length - 3, this.state.imagesDocsUrl.rg2.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="RG REPRES. LEGAL (VERSO)"
                          height="140"
                          image={this.state.imagesDocsUrl.rg2.url}
                          title="RG REPRES. LEGAL (VERSO)"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.rg2.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.rg2.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.rg2.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem CPF ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="CPF REPRES. LEGAL"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                      >
                        {
                          this.state.imagesDocsUrl.cpf.url.length > 0 ? (
                            this.state.imagesDocsUrl.cpf.url.substr(this.state.imagesDocsUrl.cpf.url.length - 3, this.state.imagesDocsUrl.cpf.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="CPF REPRES. LEGAL"
                          height="140"
                          image={this.state.imagesDocsUrl.cpf.url}
                          title="CPF REPRES. LEGAL"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.cpf.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.cpf.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.cpf.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem CNPJ ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="CNPJ"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'cnpj')}
                      >
                        {
                          this.state.imagesDocsUrl.cnpj.url.length > 0 ? (
                            this.state.imagesDocsUrl.cnpj.url.substr(this.state.imagesDocsUrl.cnpj.url.length - 3, this.state.imagesDocsUrl.cnpj.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="CNPJ"
                          height="140"
                          image={this.state.imagesDocsUrl.cnpj.url}
                          title="CNPJ"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.cnpj.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.cnpj.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.cnpj.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cnpj')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'cnpj')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem COMPROVANTE DE RESIDÊNCIA ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="COMPROVANTE DE RESIDÊNCIA"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                      >
                        {
                          this.state.imagesDocsUrl.address.url.length > 0 ? (
                            this.state.imagesDocsUrl.address.url.substr(this.state.imagesDocsUrl.address.url.length - 3, this.state.imagesDocsUrl.address.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="COMPROVANTE DE RESIDÊNCIA"
                          height="140"
                          image={this.state.imagesDocsUrl.address.url}
                          title="COMPROVANTE DE RESIDÊNCIA"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.address.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.address.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.address.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem ATO CONSTITUTIVO ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="ATO CONSTITUTIVO"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract1')}
                      >
                        {
                          this.state.imagesDocsUrl.physicalContract1.url.length > 0 ? (
                            this.state.imagesDocsUrl.physicalContract1.url.substr(this.state.imagesDocsUrl.physicalContract1.url.length - 3, this.state.imagesDocsUrl.physicalContract1.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="ATO CONSTITUTIVO"
                          height="140"
                          image={this.state.imagesDocsUrl.physicalContract1.url}
                          title="ATO CONSTITUTIVO"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.physicalContract1.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.physicalContract1.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.physicalContract1.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract1')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract1')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                  {/* ################### Imagem OUTROS ################### */}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="OUTROS"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                      >
                        {
                          this.state.imagesDocsUrl.others.url.length > 0 ? (
                            this.state.imagesDocsUrl.others.url.substr(this.state.imagesDocsUrl.others.url.length - 3, this.state.imagesDocsUrl.others.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="OUTROS"
                          height="140"
                          image={this.state.imagesDocsUrl.others.url}
                          title="OUTROS"
                        />
                            )
                          ) : (
                            this.state.imagesDocsUrl.others.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.imagesDocsUrl.others.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.imagesDocsUrl.others.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                        >
                          Selecionar
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>

                </Grid>
              </div>

              {/* Para os anexos */}
              <DropzoneDialog
                dialogTitle="Upload do arquivo"
                cancelButtonText="CANCELAR"
                submitButtonText="OK"
                getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
                open={this.state.dropzoneDialog}
                onSave={this.fileToBase64.bind(this)}
                acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', 'application/pdf']}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={this.dropzoneDialogClose.bind(this)}
                filesLimit={1}
                dropzoneText="Clique ou arraste e solte um arquivo aqui"
                previewText="Pré-visualização"
                showAlerts={false}
              />
            </div>
                  ) : (
                    this.state.stepper === 3 ? (
            <div id="contentPrint" className="formularioConteudoPaper">
              {/* <div ref={el => (this.printContent = el)}> */}
              <div>
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <Typography variant="h6" gutterBottom className="titlePaperForm">
                      Resumo
                    </Typography>
                  </div>

                  <div>
                    <Divider />
                  </div>

                  <div className="paper">
                    <Paper elevation={0} className="paperForm paper_resume">
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          EMPRESA
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={5} lg={5}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              CNPJ:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cnpj.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={12} md={7} lg={7}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              E-mail:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.infoEmailInvoice.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Tel. Fixo:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.homePhone.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Celular:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cellPhone.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              2º Celular:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cellPhone2.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Nome Fantasia:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.fantasyName.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Razão Social:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.businessName.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              CEP:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.cep.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={2} sm={2} md={2} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Logradouro:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.addressTypeToResume()}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Endereço:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.address.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={2} sm={2} md={2} lg={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Nº:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.addressNumber.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={1} sm={1} md={1} lg={1}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              UF:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.stateToResume()}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Complemento:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.addressNumber.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Município:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.cityToResume()}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Bairro:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.districtToResume()}</strong>
                            </Typography>
                          </Grid>

                        </Grid>
                      </div>
                    </Paper>

                    <Paper elevation={0} className="paperForm paper_resume" style={{marginTop: 25}}>
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          RESPONSÁVEL LEGAL
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Nome:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.legalResponsible.value}</strong>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              CPF:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              <strong>{this.state.fieldStep1.legalResponsibleCpf.value}</strong>
                            </Typography>
                          </Grid>

                        </Grid>
                      </div>
                    </Paper>

                    <Paper elevation={0} className="paperForm paper_resume" style={{marginTop: 25}}>
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          PLANOS SELECIONADOS
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            {
                              this.state.planoTipoFaixa === false ? (
                            <table
                              id="table_id"
                              className="mdl-data-table table-striped display nowrap"
                              style={{width:'100%', marginTop: 25, marginBottom: 25, borderCollapse: 'collapse', borderSpacing: 0}}
                            >
                              <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                                <tr style={this.styles.theadTr}>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                    >
                                      PLANO
                                    </Typography>
                                  </th>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                      >
                                      VAL. TITULAR
                                    </Typography>
                                  </th>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                      >
                                      VAL. DEPENDENTE
                                    </Typography>
                                  </th>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                      >
                                      VAL. AGREGADO
                                    </Typography>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                              {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                                <tr
                                  key={index}
                                  className="row_table"
                                  style={this.styles.theadTh2}
                                >
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      {item.codeS4 + ' - '+ item.name}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      {'R$ '+item.valores[0].valorTitular}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      {'R$ '+item.valores[0].valorDependente}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      {'R$ '+item.valores[0].valorAgregado}
                                    </Typography>
                                  </td>
                                </tr>
                              )}
                              </tbody>
                            </table>
                              ) : (
                            <table
                              id="table_id"
                              className="mdl-data-table table-striped display nowrap"
                              style={{width:'100%', marginTop: 25, marginBottom: 25, borderCollapse: 'collapse', borderSpacing: 0}}
                            >
                              <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                                <tr style={this.styles.theadTr}>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                    >
                                      PLANO
                                    </Typography>
                                  </th>
                                  {this.state.fieldStep1.plansListChosen.value[0].valores.map((item, index) =>
                                    (index + 1) < this.state.fieldStep1.plansListChosen.value[0].valores.length ? (
                                  <th key={index} style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                    >
                                      DE {item.qtdInicial} ATÉ {item.qtdFinal}
                                    </Typography>
                                  </th>
                                    ) : (
                                  <th key={index} style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                    >
                                      A partir de {item.qtdInicial}
                                    </Typography>
                                  </th>
                                    )
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                              {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                                <tr
                                 key={index}
                                 className="row_table"
                                 style={this.styles.theadTh2}
                                >
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {item.codeS4 + ' - '+ item.name}
                                    </Typography>
                                  </td>

                                {this.state.fieldStep1.plansListChosen.value[index].valores.map((item2, index2) =>
                                  <td key={index2} style={{padding: 0, height: 30}}>
                                    <Typography key={index2} variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {'R$ '+item2.valorTitular}
                                    </Typography>
                                  </td>
                                )}
                               </tr>
                              )}
                              </tbody>
                            </table>
                              )
                            }
                          </Grid>
                        </Grid>
                      </div>
                    </Paper>

                    <Paper elevation={0} className="paperForm paper_resume" style={{marginTop: 25}}>
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          BENEFICIÁRIOS
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <table
                              id="table_id"
                              className="mdl-data-table table-striped display nowrap"
                              style={{width:'100%', marginTop: 25, marginBottom: 25, borderCollapse: 'collapse', borderSpacing: 0}}
                            >
                              <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                                <tr style={this.styles.theadTr}>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                    >
                                      TIPO
                                    </Typography>
                                  </th>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                      >
                                      NOME
                                    </Typography>
                                  </th>
                                  <th style={{height: 30, paddingLeft: 10}}>
                                    <Typography variant="button" display="block" gutterBottom
                                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                    >
                                      CPF
                                    </Typography>
                                  </th>
                                </tr>
                              </thead>

                              {this.state.holderList.map((item, index) =>
                                index < (this.state.holderList.length - 1) && (
                              <tbody key={index}>
                                <tr
                                  className="row_table"
                                  style={this.styles.theadTh2}
                                >
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      <span
                                        style={{
                                          padding: '5px 7px', border: '1px solid '+configBase.corPrincipal,
                                          borderRadius: 5, color: configBase.corPrincipal
                                        }}
                                      >
                                        TITULAR
                                      </span>
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {item.firstName.value}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {item.cpf.value}
                                    </Typography>
                                  </td>
                                </tr>
                                {item.dependents.map((item2, index2) =>
                                  index2 < (item.dependents.length - 1) && (
                                <tr
                                  key={index2}
                                  className="row_table"
                                  style={this.styles.theadTh}
                                >
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      <span
                                        style={{
                                          padding: '5px 7px', border: '1px solid #757575',
                                          borderRadius: 5, color: '#757575'}}
                                      >
                                        DEP
                                      </span>
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 40}}
                                    >
                                      {item2.firstName.value}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 30}}></td>
                                </tr>
                                  )
                                )}
                              </tbody>
                                )
                              )}
                            </table>
                          </Grid>
                        </Grid>
                      </div>
                    </Paper>

                    <Paper elevation={0} className="paperForm paper_resume" style={{marginTop: 25}}>
                      <div className="paper">
                        <Typography
                          variant="overline" gutterBottom className="titlePaperForm"
                          style={{fontWeight: 'normal'}}
                        >
                          VALOR TOTAL
                        </Typography>
                      </div>

                      <div style={{padding: '0 20px'}}>
                        <Grid container spacing={2}>
                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Quant. de Titulares:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                            {
                              this.state.totalHolder > 9 ? (this.state.totalHolder) : ('0'+this.state.totalHolder)
                            }
                            </Typography>
                          </Grid>
                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Quant. de Titulares:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                            {
                              this.state.totalDependents > 9 ? (this.state.totalDependents) : ('0'+this.state.totalDependents)
                            }
                            </Typography>
                          </Grid>
                          <Grid item xs={3} sm={3} md={3} lg={3}>
                            <Typography variant="caption" display="block" gutterBottom style={{marginBottom: '0px'}}>
                              Valor Total:
                            </Typography>
                            <Typography variant="overline" display="block" gutterBottom style={{color: '#333'}}>
                              R$ {this.state.value_total}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    </Paper>
                  </div>
                </Paper>
              </div>

              {
                this.state.imprimir === true && (
              <div id="printOnly" ref={el => (this.printContentFinal = el)} style={{display: "none"}}>
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <div>
                      <img id="imagemId" alt="logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
                    </div>

                    <div>                    
                      <Typography style={{textAlign: 'center', color: configBase.corPrincipal}} variant="h6" gutterBottom className="titlePaperForm">
                        RESUMO DA PROPOSTA Nº {this.state.proposalNumber}
                      </Typography>                          
                    </div>
                  </div>

                  <div>
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"                            
                      >
                        EMPRESA
                      </Typography>
                    </div>

                    <div className="formPrintFields">
                      <div className="page-break" />
                      <Grid container spacing={2} className="respFinanceiro">
                        <div className="page-break" />
                        <Grid item xs={5} sm={5} md={5} lg={5} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>CNPJ:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.cnpj.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={7} sm={7} md={7} lg={7} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>E-mail:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.infoEmailInvoice.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={4} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Tel. Fixo:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.homePhone.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={4} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Celular:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.cellPhone.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={4} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>2º Celular:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.cellPhone2.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={6} sm={6} md={6} lg={6} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nome Fantasia:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.fantasyName.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={6} sm={6} md={6} lg={6} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Razão Social:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.businessName.value}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            CEP:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.state.fieldStep1.cep.value}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            Logradouro:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.addressTypeToResume()}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            Endereço:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.state.fieldStep1.address.value}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={1}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            Nº:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.state.fieldStep1.addressNumber.value}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={1}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            UF:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.stateToResume()}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            Complemento:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.state.fieldStep1.addressComplement.value}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} md={3} lg={3}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            Município:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.cityToResume()}</strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} md={3} lg={3}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            Bairro:
                          </Typography>
                          <Typography variant="overline" display="block">
                            <strong>{this.districtToResume()}</strong>
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>

                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"                            
                      >
                        RESPONSÁVEL LEGAL
                      </Typography>
                    </div>

                    <div className="page-break" />
                    <div className="formPrintFields">
                      <Grid container spacing={2} className="respFinanceiro">
                        <Grid item xs={6} sm={6} md={6} lg={6} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nome:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.legalResponsible.value}
                          </Typography>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4} lg={4} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>CPF:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {this.state.fieldStep1.legalResponsibleCpf.value}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>

                    <div className="page-break" />
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"                            
                      >
                        PLANOS SELECIONADOS
                      </Typography>
                    </div>

                    <div className="page-break" />
                    <div className="formPrintFields">
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                        {
                          this.state.planoTipoFaixa === false ? (
                          <table
                            id="table_id"
                            className="mdl-data-table display nowrap"
                            style={{width:'100%', marginTop: 8, borderCollapse: 'collapse', borderSpacing: 0}}
                          >
                            <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                              <tr style={this.styles.theadTr}>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                  >
                                    PLANO
                                  </Typography>
                                </th>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                    >
                                    VAL. TITULAR
                                  </Typography>
                                </th>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                    >
                                    VAL. DEPENDENTE
                                  </Typography>
                                </th>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                    >
                                    VAL. AGREGADO
                                  </Typography>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                            {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                              <tr
                                key={index}
                                className="row_table"
                                style={{height: 30, paddingLeft: 10, backgroundColor: '#eee'}}
                              >
                                <td style={{padding: 0, height: 30}}>
                                  <Typography variant="overline" display="block" gutterBottom
                                    style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                  >
                                    {item.codeS4 + ' - '+ item.name}
                                  </Typography>
                                </td>
                                <td style={{padding: 0, height: 30}}>
                                  <Typography variant="overline" display="block" gutterBottom
                                    style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                  >
                                    {'R$ '+item.valores[0].valorTitular}
                                  </Typography>
                                </td>
                                <td style={{padding: 0, height: 30}}>
                                  <Typography variant="overline" display="block" gutterBottom
                                    style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                  >
                                    {'R$ '+item.valores[0].valorDependente}
                                  </Typography>
                                </td>
                                <td style={{padding: 0, height: 30}}>
                                  <Typography variant="overline" display="block" gutterBottom
                                    style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                  >
                                    {'R$ '+item.valores[0].valorAgregado}
                                  </Typography>
                                </td>
                              </tr>
                            )}
                            </tbody>
                          </table>
                          ) : (
                          <table
                            id="table_id"
                            className="mdl-data-table display nowrap"
                            style={{width:'100%', marginTop: 8, borderCollapse: 'collapse', borderSpacing: 0}}
                          >
                            <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                              <tr style={this.styles.theadTr}>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                  >
                                    PLANO
                                  </Typography>
                                </th>
                                {this.state.fieldStep1.plansListChosen.value[0].valores.map((item, index) =>
                                  (index + 1) < this.state.fieldStep1.plansListChosen.value[0].valores.length ? (
                                <th key={index} style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                  >
                                    DE {item.qtdInicial} ATÉ {item.qtdFinal}
                                  </Typography>
                                </th>
                                  ) : (
                                <th key={index} style={{height: 30, paddingLeft: 10}} className='no-sort'>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                  >
                                    A partir de {item.qtdInicial}
                                  </Typography>
                                </th>
                                  )
                                )}
                              </tr>
                            </thead>
                            <tbody>
                            {this.state.fieldStep1.plansListChosen.value.map((item, index) =>
                              <tr
                                key={index}
                                className="row_table"
                                style={{height: 30, paddingLeft: 10, backgroundColor: '#eee'}}
                              >
                                <td style={{padding: 0, height: 30}}>
                                  <Typography variant="overline" display="block" gutterBottom
                                    style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                  >
                                    {item.codeS4 + ' - '+ item.name}
                                  </Typography>
                                </td>

                              {this.state.fieldStep1.plansListChosen.value[index].valores.map((item2, index2) =>
                                <td key={index2} style={{padding: 0, height: 30}}>
                                  <Typography key={index2} variant="overline" display="block" gutterBottom
                                    style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                  >
                                    {'R$ '+item2.valorTitular}
                                  </Typography>
                                </td>
                              )}
                              </tr>
                            )}
                            </tbody>
                          </table>
                          )
                        }
                        </Grid>
                      </Grid>
                    </div>

                    <div className="page-break" />
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"                            
                      >
                        BENEFICIÁRIOS
                      </Typography>
                    </div>

                    <div className="page-break" />
                    <div className="formPrintFields">
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                        <table
                          id="table_id"
                          className="mdl-data-table display nowrap"
                          style={{width:'100%', marginTop: 8, borderCollapse: 'collapse', borderSpacing: 0}}
                        >
                          <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                            <tr style={this.styles.theadTr}>
                              <th style={{height: 30, paddingLeft: 10}}>
                                <Typography variant="button" display="block" gutterBottom
                                  style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                >
                                  TIPO
                                </Typography>
                              </th>
                              <th style={{height: 30, paddingLeft: 10}}>
                                <Typography variant="button" display="block" gutterBottom
                                  style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                  >
                                  NOME
                                </Typography>
                              </th>
                              <th style={{height: 30, paddingLeft: 10}}>
                                <Typography variant="button" display="block" gutterBottom
                                  style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                >
                                  CPF
                                </Typography>
                              </th>
                            </tr>
                          </thead>

                          {this.state.holderList.map((item, index) =>
                            index < (this.state.holderList.length - 1) && (
                          <tbody key={index}>
                            <tr
                              className="row_table"
                              style={{height: 30, paddingLeft: 10, backgroundColor: '#eee'}}
                            >
                              <td style={{padding: 0, height: 30}}>
                                <Typography variant="overline" display="block" gutterBottom
                                  style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                >
                                  <span
                                    style={{
                                      padding: '5px 7px', border: '1px solid '+configBase.corPrincipal,
                                      borderRadius: 5, color: configBase.corPrincipal
                                    }}
                                  >
                                    TITULAR
                                  </span>
                                </Typography>
                              </td>
                              <td style={{padding: 0, height: 30}}>
                                <Typography variant="overline" display="block" gutterBottom
                                  style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                >
                                  {item.firstName.value}
                                </Typography>
                              </td>
                              <td style={{padding: 0, height: 30}}>
                                <Typography variant="overline" display="block" gutterBottom
                                  style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                >
                                  {item.cpf.value}
                                </Typography>
                              </td>
                            </tr>
                            {item.dependents.map((item2, index2) =>
                              index2 < (item.dependents.length - 1) && (
                            <tr
                              key={index2}
                              className="row_table"
                              style={this.styles.theadTh}
                            >
                              <td style={{padding: 0, height: 30}}>
                                <Typography variant="overline" display="block" gutterBottom
                                  style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                >
                                  <span
                                    style={{
                                      padding: '5px 7px', border: '1px solid #757575',
                                      borderRadius: 5, color: '#757575'}}
                                  >
                                    DEP
                                  </span>
                                </Typography>
                              </td>
                              <td style={{padding: 0, height: 30}}>
                                <Typography variant="overline" display="block" gutterBottom
                                  style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 40}}
                                >
                                  {item2.firstName.value}
                                </Typography>
                              </td>
                              <td style={{padding: 0, height: 30}}></td>
                            </tr>
                              )
                            )}
                          </tbody>
                            )
                          )}
                        </table>
                        </Grid>
                      </Grid>
                    </div>

                    <div className="page-break" />
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography
                        variant="overline" gutterBottom className="titlePaperForm"                            
                      >
                        VALOR TOTAL
                      </Typography>
                    </div>

                    <div className="page-break" />
                    <div className="formPrintFields">
                      <Grid container spacing={2}>
                        <Grid item xs={3} sm={3} md={3} lg={3}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Quant. de Titulares:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {
                              this.state.totalHolder > 9 ? (this.state.totalHolder) : ('0'+this.state.totalHolder)
                            }
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Quant. de Dependentes:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            {
                              this.state.totalDependents > 9 ? (this.state.totalDependents) : ('0'+this.state.totalDependents)
                            }
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3}>
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Valor Total:</strong>
                          </Typography>
                          <Typography variant="overline" display="block">
                            R$ {this.state.value_total}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>

                  </div>
                </Paper>
              </div>
                )
              }

              <Dialog
                fullScreen={this.state.fullScreenModal}
                open={this.state.finishedModal}
                onClose={this.finishedModalClose.bind(this)}
                aria-labelledby="i_modalConfirm"
              >
                <DialogTitle
                  id="i_modalConfirm"
                  style={{width: '100%', minWidth: this.state.finishedModalMinWidth}}
                >
                  {"Confirmação"}
                </DialogTitle>

                <DialogContent>
                {
                  this.state.finishedLoading === false ? (
                  <DialogContentText>
                    Deseja realmente salvar a proposta?
                  </DialogContentText>
                  ) : (
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={2} lg={2}>{''}</Grid>
                    <Grid item xs={12} sm={12} md={8} lg={8} style={{textAlign: 'center', marginTop: 30}}>
                      <LinearProgress variant="determinate" value={this.state.finishedLoadingCompleted} />
                      <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                        {this.state.finishedLoadingMsg}
                      </Typography>

                      {
                        this.state.proposalSuccess === true ? (
                      <Typography variant="overline" display="block" gutterBottom style={{marginTop: 40}}>
                        ESTA PROPOSTA FOI ENVIADA PARA ANÁLISE.<br/><br/>
                        A PROPOSTA PERMANECERÁ EM ANÁLISE ATÉ QUE SEJA VALIDADA PELA {configBase.empresaMaiuscula}.<br/><br/>
                      </Typography>
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>{''}</Grid>
                  </Grid>
                  )
                }
                </DialogContent>

                {
                  this.state.proposalSuccess === false ? (
                <DialogActions>
                  <Button autoFocus color="primary"
                    onClick={this.finishedModalClose.bind(this)}
                  >
                    NÃO
                  </Button>
                  <Button
                    color="primary"
                    onClick={this.beforeSubmitForm.bind(this)}
                    disabled={this.state.finishedLoading}
                  >
                    SIM
                  </Button>
                </DialogActions>
                  ): (
                <DialogActions>
                  <ReactToPrint                  
                    trigger={() =>
                      <div style={{marginRight: 10}}>
                        <Button 
                          color="primary"
                        >
                          IMPRIMIR
                        </Button>
                      </div>
                    }
                    content={() => this.printContentFinal}
                  />

                  <Button autoFocus color="primary"
                    onClick={this.goDashboard.bind(this)}
                  >
                    FECHAR
                  </Button>
                </DialogActions>
                  )
                }
                

              </Dialog>
            </div>
                    ) : ('')
                  )
                )
              )
            }
          </div>
        </div>

        {/* Para planilha de beneficiários */}
        {
          this.state.stepper === 1 && (
          <DropzoneDialog
            dialogTitle="Upload da planilha"
            cancelButtonText="CANCELAR"
            submitButtonText="OK"
            getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
            open={this.state.dropzoneDialog}
            onSave={this.fileToBase64UsersTable.bind(this)}
            acceptedFiles={['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
            showPreviews={true}
            maxFileSize={5000000}
            onClose={this.dropzoneDialogClose.bind(this)}
            filesLimit={1}
            dropzoneText="Clique ou arraste e solte um arquivo aqui"
            previewText="Pré-visualização"
            showAlerts={false}
          />
          )
        }

        <style>{`
          .formularioStepLabel .MuiStepIcon-root.MuiStepIcon-active {
            color: `+configBase.corPrincipal+`;
          }
          .formularioStepLabel .MuiStepIcon-root.MuiStepIcon-active .MuiStepIcon-text {
            fill: `+configBase.corSecundaria+`;
          }
          .formularioStepLabel .MuiStepLabel-label.MuiStepLabel-active {
            color: `+configBase.corPrincipal+`;
          }
        `}</style>

        <Snackbar open={this.state.warningRequest} autoHideDuration={5000} onClose={this.warningClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.warningClose.bind(this)} severity="warning" variant="filled" elevation={6}>
            {this.state.msgWarningRequest}
          </MuiAlert>
        </Snackbar>

        <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
            {this.state.msgErrorRequest}
          </MuiAlert>
        </Snackbar>
      </MainLayout>
    );

  }

}

Formulario.propTypes = {
  showFormFn: PropTypes.func,
  history: PropTypes.object
};

export default withRouter(Formulario);
